export const ruTranslations = {
  langSwitcher: {
    aria: 'Сменить язык',
  },

  nav: {
    onlinePaint: 'Рисовать',
    pngJpg: 'PNG/JPG',
    cropImage: 'Обрезать',
    rotateImage: 'Повернуть',
    blurImage: 'Размыть',
    watermarkImage: 'Водяной знак',
    photo3x4: 'Фото 3x4',
    photoCollage: 'Коллаж',
    imageGifMaker: 'GIF из фото',
    compressImage: 'Сжать',
    removeExif: 'EXIF',
    metadataViewer: 'Метаданные',
    physicalPhotoSize: 'Размер в см',
    imageWebp: 'В WebP',
    webpConverter: 'WebP/JPG',
    avifConverter: 'AVIF',
    tiffJpg: 'TIFF/JPG',
    svgConverter: 'SVG',
    htmlToImage: 'HTML',
    resizeImage: 'Размер',
    socialMediaResize: 'Для соцсетей',
    upscaleImage: 'Увеличить',
    faviconGenerator: 'Favicon',
    heicViewer: 'Открыть HEIC',
    jpgViewer: 'Открыть JPG',
    pngViewer: 'Открыть PNG',
    webpViewer: 'Открыть WebP',
    svgViewer: 'Открыть SVG',
    avifViewer: 'Открыть AVIF',
    imageColorPicker: 'Цвет с картинки',
    tiffViewer: 'Открыть TIFF',
    gifViewer: 'Открыть GIF',
    bmpViewer: 'Открыть BMP',
    icoViewer: 'Открыть ICO',
    heicJpg: 'HEIC/JPG',
    blog: 'Блог',
  },

  badge: {
    local: 'Локально',
    server: 'На сервере',
    localFirst: 'Локально*',
    localTitle: 'Файл обрабатывается прямо в браузере и не отправляется на сервер',
    serverTitle: 'Файл отправляется на сервер для обработки',
    localFirstTitle:
      'По умолчанию обрабатывается в браузере. Опционально можно отправить на сервер для более глубокого сжатия.',
  },

  common: {
    formats: 'PNG, JPG, JPEG',
    maxFileSize: 'До 50 MB',
    maxFileSizePerFile: 'До 50 MB на файл',
    open: 'Открыть',
    convert: 'Конвертировать',
    converting: 'Конвертация...',
    download: 'Скачать',
    done: 'Готово',
    remove: 'Удалить',
    errorConverting: 'Ошибка конвертации',
    batch: 'Пакетно',
    imageTools: 'Инструменты для изображений',
    faq: 'Вопросы',
    updated: 'Обновлено',
    allBlogPosts: 'Все записи блога',
  },

  index: {
    title: 'Инструменты для изображений',
    description:
      'Откройте, сконвертируйте или отредактируйте изображение прямо в браузере. Без регистрации и водяных знаков.',
    searchPlaceholder: 'Найти инструмент: png, сжать, обрезать',
    searchEmpty: 'Ничего не нашлось. Попробуйте другое слово, например формат файла.',
    groups: [
      { key: 'open', title: 'Открыть файл' },
      { key: 'convert', title: 'Конвертировать' },
      { key: 'size', title: 'Сжать и изменить размер' },
      { key: 'edit', title: 'Редактировать' },
      { key: 'create', title: 'Создать' },
      { key: 'data', title: 'Цвет и метаданные' },
    ],
    tools: [
      {
        group: 'open',
        title: 'Открыть PNG',
        description: 'С прозрачностью на шахматном фоне.',
        href: '/otkryt-png',
        formats: ['PNG', 'просмотр', 'посмотреть'],
      },
      {
        group: 'open',
        title: 'Открыть SVG',
        description: 'Безопасный просмотр и сохранение в PNG или JPG.',
        href: '/otkryt-svg',
        formats: ['SVG', 'вектор', 'просмотр'],
      },
      {
        group: 'open',
        title: 'Открыть HEIC',
        description: 'Фото с iPhone в браузере, копия в JPG или PNG.',
        href: '/otkryt-heic',
        formats: ['HEIC', 'HEIF', 'iPhone', 'просмотр'],
      },
      {
        group: 'open',
        title: 'Открыть JPG',
        description: 'Просмотр, вес, габариты и следующие действия.',
        href: '/otkryt-jpg',
        formats: ['JPG', 'JPEG', 'просмотр'],
      },
      {
        group: 'open',
        title: 'Открыть WebP',
        description: 'Просмотр и сохранение кадра в JPG или PNG.',
        href: '/otkryt-webp',
        formats: ['WebP', 'просмотр'],
      },
      {
        group: 'open',
        title: 'Открыть AVIF',
        description: 'Просмотр и сохранение в JPG или PNG.',
        href: '/otkryt-avif',
        formats: ['AVIF', 'просмотр'],
      },
      {
        group: 'open',
        title: 'Открыть TIFF',
        description: 'Первый кадр и сохранение в JPG.',
        href: '/otkryt-tiff',
        formats: ['TIFF', 'TIF', 'просмотр'],
      },
      {
        group: 'open',
        title: 'Открыть GIF',
        description: 'Анимация в браузере и первый кадр в PNG.',
        href: '/otkryt-gif',
        formats: ['GIF', 'анимация', 'просмотр'],
      },
      {
        group: 'open',
        title: 'Открыть BMP',
        description: 'Просмотр и копия в PNG или JPG.',
        href: '/otkryt-bmp',
        formats: ['BMP', 'DIB', 'просмотр'],
      },
      {
        group: 'open',
        title: 'Открыть ICO',
        description: 'Значок, размеры внутри файла и копия в PNG.',
        href: '/otkryt-ico',
        formats: ['ICO', 'значок', 'иконка', 'favicon', 'просмотр'],
      },
      {
        group: 'convert',
        title: 'Конвертер PNG и JPG',
        description: 'PNG в JPG и JPG в PNG, несколько файлов сразу.',
        href: '/konverter-izobrazheniy',
        formats: ['PNG', 'JPG', 'JPEG'],
      },
      {
        group: 'convert',
        title: 'HEIC в JPG, PNG или WebP',
        description: 'До 10 файлов с выбором формата.',
        href: '/heic-v-jpg',
        formats: ['HEIC', 'HEIF', 'JPG', 'PNG', 'WebP', 'iPhone'],
      },
      {
        group: 'convert',
        title: 'JPG и PNG в WebP',
        description: 'Лёгкие WebP для сайта, ZIP для нескольких файлов.',
        href: '/v-webp',
        formats: ['JPG', 'PNG', 'WebP'],
      },
      {
        group: 'convert',
        title: 'WebP в JPG или PNG',
        description: 'Привычный формат с настройкой качества.',
        href: '/webp-v-jpg-png',
        formats: ['WebP', 'JPG', 'PNG'],
      },
      {
        group: 'convert',
        title: 'Конвертер AVIF',
        description: 'JPG, PNG и WebP в AVIF и обратно.',
        href: '/avif-konverter',
        formats: ['AVIF', 'JPG', 'PNG', 'WebP'],
      },
      {
        group: 'convert',
        title: 'TIFF в JPG',
        description: 'Несколько файлов и настройка качества.',
        href: '/tiff-v-jpg',
        formats: ['TIFF', 'TIF', 'JPG'],
      },
      {
        group: 'convert',
        title: 'SVG в PNG или JPG',
        description: 'Растровая копия нужного размера.',
        href: '/svg-v-png-jpg',
        formats: ['SVG', 'PNG', 'JPG'],
      },
      {
        group: 'convert',
        title: 'HTML в картинку',
        description: 'Вставьте код и скачайте PNG или JPG.',
        href: '/html-v-kartinku',
        formats: ['HTML', 'PNG', 'JPG', 'скриншот'],
      },
      {
        group: 'size',
        title: 'Сжать изображение',
        description: 'Уменьшить вес JPG, PNG или WebP, можно до заданного размера.',
        href: '/szhat-izobrazhenie',
        formats: ['JPG', 'PNG', 'WebP', 'вес', 'сжать'],
      },
      {
        group: 'size',
        title: 'Изменить размер фото',
        description: 'Новая ширина и высота, 50%, 25% или свой размер.',
        href: '/izmenit-razmer-foto',
        formats: ['JPG', 'PNG', 'WebP', 'уменьшить', 'ресайз'],
      },
      {
        group: 'size',
        title: 'Размер фото для соцсетей',
        description: 'До 24 кадров для шести форматов, отдельно или в ZIP.',
        href: '/razmer-foto-dlya-socsetey',
        formats: ['JPG', 'ZIP', 'соцсети'],
      },
      {
        group: 'size',
        title: 'Увеличить фото',
        description: 'В 2, 3 или 4 раза либо до своего размера.',
        href: '/uvelichit-foto',
        formats: ['JPG', 'PNG', 'WebP', 'разрешение'],
      },
      {
        group: 'size',
        title: 'Фото 3x4',
        description: 'Кадр под документы: 300x400, 600x800 или свой размер.',
        href: '/foto-3x4',
        formats: ['JPG', 'PNG', 'WebP', '3x4', 'документы'],
      },
      {
        group: 'size',
        title: 'Размер фото в сантиметрах',
        description: 'Узнать размер при печати и PPI.',
        href: '/razmer-foto-v-sm',
        formats: ['JPG', 'PNG', 'WebP', 'DPI', 'PPI', 'печать'],
      },
      {
        group: 'edit',
        title: 'Обрезать фото',
        description: 'Свободная рамка и популярные пропорции.',
        href: '/obrezat-foto',
        formats: ['JPG', 'PNG', 'WebP', 'кадрировать'],
      },
      {
        group: 'edit',
        title: 'Повернуть фото',
        description: 'На 90, 180 или 270 градусов, отражение.',
        href: '/povernut-foto',
        formats: ['JPG', 'PNG', 'WebP', 'отразить'],
      },
      {
        group: 'edit',
        title: 'Размыть фото',
        description: 'Закрыть лицо или текст размытием либо пикселями.',
        href: '/razmyt-foto',
        formats: ['JPG', 'PNG', 'WebP', 'пиксели', 'скрыть'],
      },
      {
        group: 'edit',
        title: 'Водяной знак на фото',
        description: 'Текст поверх JPG, PNG или WebP.',
        href: '/vodyanoj-znak-na-foto',
        formats: ['JPG', 'PNG', 'WebP', 'подпись'],
      },
      {
        group: 'create',
        title: 'Рисовать онлайн',
        description: 'Холст, кисть, фигуры, стрелки и текст.',
        href: '/risovat-online',
        formats: ['PNG', 'JPG', 'WebP', 'рисунок'],
      },
      {
        group: 'create',
        title: 'Коллаж из фото',
        description: 'От 2 до 12 фотографий в готовой сетке.',
        href: '/kollazh-iz-foto',
        formats: ['JPG', 'PNG', 'WebP', 'коллаж'],
      },
      {
        group: 'create',
        title: 'Создать GIF из фото',
        description: 'От 2 до 20 кадров с задержками и повторами.',
        href: '/sozdat-gif-iz-foto',
        formats: ['JPG', 'PNG', 'WebP', 'GIF', 'анимация'],
      },
      {
        group: 'create',
        title: 'Генератор favicon',
        description: 'ZIP с набором значков для сайта.',
        href: '/favicon-generator',
        formats: ['PNG', 'JPG', 'WebP', 'ZIP', 'ICO', 'иконка'],
      },
      {
        group: 'data',
        title: 'Выбрать цвет с картинки',
        description: 'Точный цвет пикселя в HEX, RGB, HSL или HSV.',
        href: '/vybrat-cvet-s-kartinki',
        formats: ['JPG', 'PNG', 'WebP', 'HEX', 'пипетка'],
      },
      {
        group: 'data',
        title: 'Посмотреть EXIF и метаданные',
        description: 'Камера, дата и координаты в JPG, TIFF или HEIC.',
        href: '/posmotret-exif',
        formats: ['JPG', 'TIFF', 'HEIC', 'EXIF', 'геолокация'],
      },
      {
        group: 'data',
        title: 'Удалить EXIF',
        description: 'Очистить JPG от метаданных перед публикацией.',
        href: '/udalit-exif',
        formats: ['JPG', 'JPEG', 'EXIF', 'геолокация'],
      },
    ],
  },

  rotateImage: {
    eyebrow: 'Поворот и отражение',
    title: 'Повернуть фото онлайн',
    description:
      'Загрузите JPG, PNG или WebP, поверните фото на 90/180/270 градусов или отразите его. Результат сохраняется локально в браузере без отправки файла на сервер.',
    formats: 'JPG, PNG, WebP',
    dropTitle: 'Перетащите изображение сюда',
    dropDescription:
      'Выберите JPG, PNG или WebP до 50 MB. После загрузки можно повернуть фото или отразить его по горизонтали и вертикали.',
    chooseFile: 'Выбрать изображение',
    replaceImage: 'Заменить',
    settings: 'Поворот',
    before: 'До',
    after: 'После',
    waitingPreview: 'После поворота',
    notReady: 'Выберите действие',
    download: 'Скачать результат',
    summary: 'Сводка',
    originalSize: 'Исходный файл',
    originalDimensions: 'Исходный размер',
    resultSize: 'После обработки',
    rotationLabel: 'Поворот',
    flipLabel: 'Отражение',
    flipHorizontalShort: 'гориз.',
    flipVerticalShort: 'верт.',
    none: 'нет',
    privacyNote:
      'Файл не отправляется на сервер. Изображение открывается и сохраняется прямо в браузере.',
    controls: [
      { action: 'rotate-left', label: 'Влево 90°' },
      { action: 'rotate-right', label: 'Вправо 90°' },
      { action: 'rotate-180', label: 'Повернуть на 180°' },
      { action: 'flip-horizontal', label: 'Отразить горизонтально' },
      { action: 'flip-vertical', label: 'Отразить вертикально' },
    ],
    howTo: [
      'Выберите JPG, PNG или WebP файл на устройстве.',
      'Нажмите поворот влево, вправо, 180 градусов или отражение по нужной оси.',
      'Проверьте предпросмотр результата и скачайте готовое изображение.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только JPG, PNG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeImage:
        'Изображение слишком большое для обработки в браузере. Попробуйте файл с меньшим разрешением.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для поворота.',
      unsupportedOutput:
        'Этот браузер не умеет сохранять результат в исходном формате WebP.',
      transformFailed: 'Не удалось повернуть изображение.',
      noImage: 'Сначала выберите изображение.',
    },
    faq: [
      {
        question: 'Файл отправляется на сервер?',
        answer:
          'Нет. Изображение открывается, поворачивается и сохраняется прямо в браузере. Файл остаётся на вашем устройстве.',
      },
      {
        question: 'Какие действия доступны?',
        answer:
          'Можно повернуть фото влево или вправо на 90 градусов, повернуть на 180 градусов, а также отразить горизонтально или вертикально.',
      },
      {
        question: 'В каком формате скачивается результат?',
        answer:
          'Страница старается сохранить исходный формат: JPG остаётся JPG, PNG остаётся PNG, WebP остаётся WebP, если браузер поддерживает такой экспорт.',
      },
    ],
  },

  svgViewer: {
    howToTitle: 'Как пользоваться',
    eyebrow: 'Безопасный просмотр SVG',
    title: 'Открыть SVG онлайн',
    description:
      'Откройте и посмотрите SVG онлайн без загрузки на сервер. Перед показом файл проверяется как XML, активное содержимое и внешние ресурсы блокируются.',
    acceptedFormats: 'SVG',
    dropTitle: 'Перетащите SVG сюда',
    dropDescription:
      'Выберите один SVG до 10 MB. Перед показом страница очистит файл.',
    chooseFile: 'Выбрать SVG',
    loading: 'Проверяем SVG...',
    previewTitle: 'Очищенный предпросмотр SVG',
    previewAlt: 'Безопасный предпросмотр очищенного SVG',
    dimensions: 'Габариты',
    dimensionsMissing: 'Не указаны в SVG',
    exportDescription:
      'Сохраните очищенный SVG как PNG или JPG. JPG получит белый фон.',
    exportPng: 'Скачать PNG',
    exportJpg: 'Скачать JPG',
    exporting: 'Готовим...',
    exportMissingDimensions:
      'Для экспорта SVG должен содержать width и height либо корректный viewBox. Просмотр доступен и без них.',
    exportFailed: 'Не удалось экспортировать SVG. Попробуйте другой файл.',
    relatedToolsTitle: 'Что сделать с SVG дальше',
    privacyNote:
      'Файл не отправляется на сервер. Предпросмотр создаётся только из очищенной SVG-копии; исходная разметка не вставляется в страницу и не исполняется.',
    relatedTools: [
      {
        title: 'SVG в PNG или JPG',
        description: 'Выбрать размер результата, формат и цвет фона для JPG.',
        href: '/svg-v-png-jpg',
      },
      {
        title: 'Генератор favicon',
        description: 'Подготовить набор favicon из изображения для сайта.',
        href: '/favicon-generator',
      },
      {
        title: 'Изменить размер изображения',
        description: 'Задать новую ширину и высоту растровой копии.',
        href: '/izmenit-razmer-foto',
      },
    ],
    howTo: [
      'Выберите один SVG-файл на устройстве или перетащите его в область загрузки.',
      'Дождитесь проверки XML и очистки активного содержимого, затем рассмотрите безопасный предпросмотр.',
      'Проверьте имя, размер и обнаруженные габариты; при необходимости скачайте PNG или JPG как дополнительный результат.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только SVG-файлы.',
      too_large: 'SVG слишком большой. Максимальный размер — 10 MB.',
      too_large_image: 'SVG задаёт слишком большой размер изображения.',
      corrupt: 'Не удалось прочитать SVG. Проверьте XML-разметку и структуру файла.',
      decode_failure: 'Браузер не смог показать очищенный SVG. Возможно, в нём есть неподдерживаемые конструкции.',
    },
    processingErrors: {
      unsupported: 'Поддерживаются только SVG-файлы.',
      tooLarge: 'SVG слишком большой. Максимальный размер — 10 MB.',
      invalidSvg: 'Файл содержит повреждённый XML или не является корректным SVG.',
      unsafeSvg: 'SVG содержит активное или небезопасное содержимое и не может быть показан.',
      externalResource:
        'SVG ссылается на внешний ресурс. Для безопасного просмотра все ресурсы должны быть внутри файла.',
      unsupportedSvg:
        'Браузер не смог отрисовать очищенный SVG. Возможно, файл использует неподдерживаемые конструкции.',
      canvas: 'Размер SVG слишком велик для экспорта.',
      conversion: 'Не удалось экспортировать SVG в выбранный формат.',
    },
    faq: [
      {
        question: 'SVG отправляется на сервер?',
        answer:
          'Нет. Чтение, проверка, очистка, предпросмотр и экспорт выполняются локально в браузере. Файл остаётся на устройстве.',
      },
      {
        question: 'Безопасно ли открывать SVG в браузере?',
        answer:
          'Перед показом блокируются скрипты, обработчики событий, foreignObject, внешние ссылки и опасные CSS-конструкции. Показывается только сериализованная очищенная копия.',
      },
      {
        question: 'Почему SVG может не открыться?',
        answer:
          'Страница отклоняет повреждённый XML, активное содержимое, внешние ресурсы и SVG-конструкции, которые браузер не умеет безопасно отрисовать как изображение.',
      },
      {
        question: 'Можно ли сохранить SVG как PNG или JPG?',
        answer:
          'Да, это дополнительное действие после просмотра. Для экспорта нужны width и height либо корректный viewBox; JPG сохраняется с белым фоном.',
      },
    ],
  },

  tiffViewer: {
    howToTitle: 'Как пользоваться', eyebrow: 'Просмотр TIFF', title: 'Открыть TIFF онлайн',
    description: 'Откройте TIFF или TIF онлайн и посмотрите первый кадр локально в браузере.',
    acceptedFormats: 'TIFF, TIF', dropTitle: 'Перетащите TIFF или TIF сюда',
    dropDescription: 'Выберите один файл TIFF или TIF.', chooseFile: 'Выбрать TIFF',
    loading: 'Декодируем TIFF...', previewTitle: 'Первый кадр TIFF', previewAlt: 'Предпросмотр первого кадра TIFF', 
    dimensions: 'Габариты первого кадра', frames: 'Страницы / кадры',
    downloadJpg: 'Скачать первый кадр в JPG', exportingJpg: 'Готовим JPG...',
    exportError: 'Не удалось скачать JPG. Попробуйте открыть TIFF ещё раз.', relatedToolsTitle: 'Другие действия с TIFF',
    multiFrameWarning: 'Файл содержит несколько страниц или кадров. Показывается и экспортируется только первый кадр.',
    privacyNote: 'Файл не отправляется на сервер. TIFF декодируется локально, а копия для просмотра создаётся в браузере.',
    relatedTools: [
      { title: 'TIFF в JPG', description: 'Конвертировать несколько TIFF.', href: '/tiff-v-jpg' },
      { title: 'Сжать изображение', description: 'Уменьшить вес JPG-копии.', href: '/szhat-izobrazhenie' },
      { title: 'Изменить размер', description: 'Задать новые размеры изображения.', href: '/izmenit-razmer-foto' },
    ],
    howTo: ['Выберите один файл TIFF или TIF.', 'Посмотрите первый кадр и число страниц.', 'При необходимости скачайте первый кадр в JPG.'],
    errorsText: {
      unsupported: 'Поддерживаются только файлы TIFF и TIF.', too_large: 'Файл слишком большой. Максимальный размер — 50 MB.',
      too_large_image: 'Кадр TIFF превышает безопасные лимиты браузера.', corrupt: 'Файл TIFF повреждён или имеет неверный формат.',
      decode_failure: 'Не удалось открыть TIFF. Возможно, используется неподдерживаемое сжатие или вариант формата.',
    },
    faq: [
      { question: 'TIFF отправляется на сервер?', answer: 'Нет. Проверка, декодирование, предпросмотр и JPG-экспорт выполняются локально в браузере.' },
      { question: 'Что произойдёт с многостраничным TIFF?', answer: 'Страница показывает число страниц, но отображает и экспортирует только первый кадр.' },
      { question: 'Можно сохранить TIFF как JPG?', answer: 'Да. Скачайте показанный первый кадр как JPG.' },
    ],
  },

  avifViewer: {
    howToTitle: 'Как пользоваться', eyebrow: 'Просмотр AVIF', title: 'Открыть AVIF онлайн', description: 'Откройте AVIF прямо в браузере: просмотр, габариты файла и экспорт в JPG или PNG без загрузки на сервер.', acceptedFormats: 'AVIF', dropTitle: 'Перетащите AVIF сюда', dropDescription: 'Выберите один AVIF до 50 MB.', chooseFile: 'Выбрать AVIF', loading: 'Открываем...', previewTitle: 'Просмотр AVIF', previewAlt: 'Изображение AVIF', dimensions: 'Габариты', relatedToolsTitle: 'Следующие шаги', privacyNote: 'Файл не отправляется на сервер.', exportDescription: 'PNG сохраняет прозрачность, JPG заполняет прозрачные области белым.', downloadJpg: 'Скачать JPG', downloadPng: 'Скачать PNG', exportingJpg: 'Готовим JPG...', exportingPng: 'Готовим PNG...', exportError: 'Не удалось скачать изображение.', exportLimit: 'Экспорт JPG и PNG доступен для изображений до 16 мегапикселей.', relatedTools: [{ title: 'AVIF конвертер', description: 'Конвертировать AVIF.', href: '/avif-konverter' }, { title: 'Сжать изображение', description: 'Уменьшить вес изображения.', href: '/szhat-izobrazhenie' }, { title: 'Изменить размер', description: 'Задать новые размеры.', href: '/izmenit-razmer-foto' }], howTo: ['Выберите один .avif файл на устройстве.', 'Дождитесь открытия и проверьте габариты.', 'При необходимости скачайте JPG или PNG.'], errorsText: { unsupported: 'Поддерживаются только AVIF изображения.', too_large: 'Файл слишком большой. Максимальный размер — 50 MB.', too_large_image: 'Изображение больше 36 мегапикселей.', corrupt: 'Не удалось открыть AVIF. Файл повреждён или использует неподдерживаемый вариант.', decode_failure: 'Этот браузер не умеет открывать AVIF.' }, faq: [{ question: 'AVIF отправляется на сервер?', answer: 'Нет. Все операции выполняются локально в браузере.' }, { question: 'Почему AVIF не открывается?', answer: 'Файл может быть повреждён или использовать неподдерживаемый вариант AVIF.' }, { question: 'Можно сохранить AVIF как JPG или PNG?', answer: 'Да, после успешного открытия.' }],
  },

  imageColorPicker: {
    eyebrow: 'Пипетка для изображения',
    title: 'Выбрать цвет с картинки онлайн',
    description:
      'Загрузите JPG, PNG или WebP, увеличьте изображение и нажмите на нужный пиксель. Файл остаётся в браузере, а цвет можно скопировать в HEX, RGB, HSL или HSV.',
    dropTitle: 'Перетащите изображение или выберите файл',
    dropHint: 'Также можно вставить картинку из буфера обмена. Удалённые URL не поддерживаются: файл никуда не отправляется.',
    loading: 'Открываем изображение…',
    fit: 'Сбросить вид',
    zoomOut: 'Уменьшить',
    zoomIn: 'Увеличить',
    canvasLabel: 'Изображение для выбора цвета',
    canvasKeyboardHint:
      'Для навигации используйте стрелки, для выбора пикселя нажмите Enter или пробел. Shift + стрелка перемещает на 10 пикселей.',
    pixelAnnouncement: 'Пиксель {x} по горизонтали, {y} по вертикали.',
    selectedAnnouncement: ' Выбран цвет {color}.',
    canvasHint: 'Наведите для лупы, нажмите или коснитесь для фиксации цвета. Перетащите изображение, чтобы переместить его после увеличения. Также доступно управление с клавиатуры: фокус на изображение, стрелки для навигации, Enter для выбора.',
    resultTitle: 'Выбранный цвет',
    noSelection: 'Нажмите на пиксель изображения',
    transparent: 'Пиксель полностью прозрачный. Значения каналов показаны без смешивания с шахматным фоном.',
    copied: 'Скопировано',
    reset: 'Открыть другое изображение',
    faqTitle: 'Вопросы о выборе цвета',
    relatedTitle: 'Другие инструменты для изображения',
    relatedCrop: 'Обрезать фото',
    relatedResize: 'Изменить размер',
    relatedCompress: 'Сжать изображение',
    howTo: [
      'Загрузите JPG, PNG или WebP через выбор файла, drag-and-drop или вставку из буфера.',
      'Увеличьте и переместите изображение, затем наведите лупу на нужный пиксель.',
      'Нажмите или коснитесь пикселя и скопируйте HEX, RGB, HSL или HSV.',
    ],
    errors: {
      unsupported: 'Поддерживаются только JPG, PNG и WebP.',
      tooLarge: 'Файл больше 50 MB. Выберите изображение меньшего размера.',
      tooManyPixels: 'Изображение больше 16 мегапикселей. Уменьшите его перед выбором цвета.',
      corrupt: 'Не удалось распознать изображение. Файл повреждён или его формат не соответствует расширению.',
      canvas: 'Браузер не смог подготовить изображение для чтения пикселей.',
      copy: 'Не удалось скопировать значение. Выделите его вручную.',
    },
    faq: [
      {
        question: 'Изображение отправляется на сервер?',
        answer: 'Нет. Файл открывается и читается прямо в браузере. Его содержимое не покидает устройство.',
      },
      {
        question: 'Почему у прозрачного PNG указан восьмизначный HEX?',
        answer: 'Последние две цифры HEX8 хранят alpha-канал. Инструмент не смешивает прозрачный пиксель с фоном и также показывает rgba и hsla.',
      },
      {
        question: 'Можно выбрать цвет по URL сайта?',
        answer: 'Нет. Страница принимает только файл с устройства или картинку из буфера обмена.',
      },
      {
        question: 'Какое цветовое пространство используется?',
        answer: 'Браузер возвращает пиксели в sRGB. Исходные Display-P3 и ICC-профили отдельно не сохраняются и не анализируются.',
      },
    ],
  },

  viewer: {
    nextStepsTitle: 'Что сделать с файлом',
    downloadPng: 'Скачать PNG',
    downloadJpg: 'Скачать JPG',
    preparing: 'Готовим файл...',
    exportError: 'Не удалось сохранить файл. Откройте его заново и попробуйте ещё раз.',
    compress: 'Сжать',
    crop: 'Обрезать',
    resize: 'Изменить размер',
    convert: 'Конвертировать',
    saveCopyFirst: 'Сжатие, обрезка и изменение размера работают с JPG, PNG и WebP. Сначала скачайте копию.',
    openAnother: 'Открыть другой файл',
    cancel: 'Отменить',
    otherFormatsTitle: 'Открыть другой формат',
    factsTitle: 'Сведения о файле',
    fileName: 'Имя',
    fileSize: 'Размер файла',
    mimeType: 'MIME',
    format: 'Формат',
    zoomFit: 'Вписать',
    zoomOut: 'Уменьшить',
    zoomIn: 'Увеличить',
  },

  gifViewer: {
    howToTitle: 'Как пользоваться',
    eyebrow: 'Просмотр GIF',
    title: 'Открыть GIF онлайн',
    description: 'Откройте GIF онлайн: анимация проигрывается прямо в браузере, а файл остаётся на устройстве. Первый кадр можно скачать в PNG или JPG.',
    acceptedFormats: 'GIF',
    dropTitle: 'Перетащите GIF сюда',
    dropDescription: 'Выберите один GIF до 50 MB.',
    chooseFile: 'Выбрать GIF',
    loading: 'Открываем...',
    previewTitle: 'Просмотр GIF',
    previewAlt: 'Открытый файл GIF',
    dimensions: 'Габариты',
    relatedToolsTitle: 'Другие действия с GIF',
    privacyNote: 'Файл не отправляется на сервер. GIF проверяется и проигрывается браузером на вашем устройстве.',
    exportNote: 'PNG и JPG сохраняют первый кадр. JPG заменяет прозрачность белым фоном.',
    relatedTools: [
      {
        title: 'Создать GIF из фото',
        description: 'Собрать анимацию из нескольких изображений.',
        href: '/sozdat-gif-iz-foto',
      },
      {
        title: 'Сжать изображение',
        description: 'Уменьшить вес сохранённого кадра.',
        href: '/szhat-izobrazhenie',
      },
      {
        title: 'Открыть WebP',
        description: 'Посмотреть анимацию или кадр в WebP.',
        href: '/otkryt-webp',
      },
    ],
    howTo: [
      'Выберите один файл GIF на устройстве или перетащите его в область загрузки.',
      'Посмотрите анимацию и проверьте имя, размер файла и габариты.',
      'При необходимости скачайте первый кадр в PNG или JPG.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только изображения GIF.',
      too_large: 'Файл слишком большой. Максимальный размер — 50 MB.',
      too_large_image: 'GIF слишком большой для открытия в браузере. Попробуйте изображение меньше 36 мегапикселей.',
      corrupt: 'Заголовок GIF не найден. Файл повреждён или имеет неверное расширение.',
      decode_failure: 'Браузер не смог открыть GIF. Попробуйте пересохранить файл.',
    },
    faq: [
      {
        question: 'GIF отправляется на сервер?',
        answer: 'Нет. Файл открывается в браузере и не покидает устройство.',
      },
      {
        question: 'Анимация будет проигрываться?',
        answer: 'Да. Браузер проигрывает анимированный GIF так же, как на обычной странице, с задержками и повторами из файла.',
      },
      {
        question: 'Можно сохранить GIF как PNG или JPG?',
        answer: 'Да, но только первый кадр: PNG и JPG не хранят анимацию. PNG сохраняет прозрачность, JPG заменяет её белым фоном.',
      },
    ],
  },

  bmpViewer: {
    howToTitle: 'Как пользоваться',
    eyebrow: 'Просмотр BMP',
    title: 'Открыть BMP онлайн',
    description: 'Откройте BMP онлайн, проверьте габариты и скачайте копию в PNG или JPG. Файл остаётся на устройстве.',
    acceptedFormats: 'BMP, DIB',
    dropTitle: 'Перетащите BMP сюда',
    dropDescription: 'Выберите один BMP до 50 MB.',
    chooseFile: 'Выбрать BMP',
    loading: 'Открываем...',
    previewTitle: 'Просмотр BMP',
    previewAlt: 'Открытый файл BMP',
    dimensions: 'Габариты',
    relatedToolsTitle: 'Другие действия с BMP',
    privacyNote: 'Файл не отправляется на сервер. BMP проверяется и открывается браузером на вашем устройстве.',
    relatedTools: [
      {
        title: 'Сжать изображение',
        description: 'Уменьшить вес копии в PNG или JPG.',
        href: '/szhat-izobrazhenie',
      },
      {
        title: 'Изменить размер',
        description: 'Задать новую ширину и высоту копии.',
        href: '/izmenit-razmer-foto',
      },
      {
        title: 'Открыть TIFF',
        description: 'Посмотреть другой несжатый растровый формат.',
        href: '/otkryt-tiff',
      },
    ],
    howTo: [
      'Выберите один файл BMP на устройстве или перетащите его в область загрузки.',
      'Рассмотрите изображение и проверьте имя, размер файла и габариты.',
      'При необходимости скачайте копию в PNG или JPG.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только изображения BMP.',
      too_large: 'Файл слишком большой. Максимальный размер — 50 MB.',
      too_large_image: 'BMP слишком большой для открытия в браузере. Попробуйте изображение меньше 36 мегапикселей.',
      corrupt: 'Заголовок BMP не найден. Файл повреждён или имеет неверное расширение.',
      decode_failure: 'Браузер не смог открыть BMP. Возможно, файл использует редкий вариант формата.',
    },
    faq: [
      {
        question: 'BMP отправляется на сервер?',
        answer: 'Нет. Файл открывается в браузере и не покидает устройство.',
      },
      {
        question: 'Почему BMP весит так много?',
        answer: 'BMP обычно хранит пиксели без сжатия. Копия в PNG сохранит те же пиксели и займёт заметно меньше места.',
      },
      {
        question: 'Как сохранить BMP в PNG или JPG?',
        answer: 'Откройте файл и нажмите кнопку скачивания. Копия создаётся в браузере в тех же габаритах.',
      },
    ],
  },

  icoViewer: {
    howToTitle: 'Как пользоваться',
    eyebrow: 'Просмотр ICO',
    title: 'Открыть ICO онлайн',
    description: 'Откройте ICO онлайн, посмотрите значок, список размеров внутри файла и скачайте копию в PNG или JPG. Файл остаётся на устройстве.',
    acceptedFormats: 'ICO',
    dropTitle: 'Перетащите ICO сюда',
    dropDescription: 'Выберите один ICO до 10 MB.',
    chooseFile: 'Выбрать ICO',
    loading: 'Открываем...',
    previewTitle: 'Просмотр ICO',
    previewAlt: 'Открытый значок ICO',
    dimensions: 'Показанный размер',
    storedSizes: 'Размеры в файле',
    relatedToolsTitle: 'Другие действия с ICO',
    privacyNote: 'Файл не отправляется на сервер. ICO проверяется и открывается браузером на вашем устройстве.',
    exportNote: 'Браузер показывает один размер из файла, он же попадает в копию. JPG заменяет прозрачность белым фоном.',
    relatedTools: [
      {
        title: 'Генератор favicon',
        description: 'Собрать набор значков для сайта из изображения.',
        href: '/favicon-generator',
      },
      {
        title: 'Открыть PNG',
        description: 'Проверить прозрачность скачанной копии.',
        href: '/otkryt-png',
      },
      {
        title: 'Открыть SVG',
        description: 'Посмотреть векторный значок.',
        href: '/otkryt-svg',
      },
    ],
    howTo: [
      'Выберите один файл ICO на устройстве или перетащите его в область загрузки.',
      'Посмотрите значок на шахматном фоне и список размеров внутри файла.',
      'При необходимости скачайте копию в PNG или JPG.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только файлы ICO.',
      too_large: 'Файл слишком большой. Максимальный размер — 10 MB.',
      too_large_image: 'Значок слишком большой для открытия в браузере.',
      corrupt: 'Заголовок ICO не найден. Файл повреждён или имеет неверное расширение.',
      decode_failure: 'Браузер не смог открыть ICO. Попробуйте другой браузер или пересохраните значок.',
    },
    faq: [
      {
        question: 'ICO отправляется на сервер?',
        answer: 'Нет. Файл открывается в браузере и не покидает устройство.',
      },
      {
        question: 'Почему в ICO несколько размеров?',
        answer: 'Один файл ICO может хранить значок в разных размерах, например 16, 32 и 48 пикселей. Страница показывает их список.',
      },
      {
        question: 'Можно сохранить ICO как PNG?',
        answer: 'Да. Копия PNG сохраняет прозрачность и получает тот размер, который показал браузер.',
      },
    ],
  },

  pngViewer: {
    howToTitle: 'Как пользоваться',
    eyebrow: 'Просмотр PNG',
    title: 'Открыть PNG онлайн',
    description:
      'Откройте PNG онлайн и рассмотрите прозрачные области на шахматном фоне. Имя, размер файла, габариты и формат определяются локально в браузере.',
    acceptedFormats: 'PNG',
    dropTitle: 'Перетащите PNG сюда',
    dropDescription:
      'Выберите один PNG до 50 MB.',
    chooseFile: 'Выбрать PNG',
    loading: 'Открываем...',
    previewTitle: 'Просмотр PNG',
    previewAlt: 'Предпросмотр PNG на фоне для прозрачности',
    dimensions: 'Габариты',
    exportNote: 'JPG заменяет прозрачность белым фоном.',
    relatedToolsTitle: 'Другие действия с PNG',
    privacyNote:
      'Файл не отправляется на сервер. PNG проверяется и открывается средствами браузера, а просмотр и сведения о файле рассчитываются на устройстве.',
    relatedTools: [
      {
        title: 'PNG -> JPG',
        description: 'Получить JPG-копию с фоном для сервисов без поддержки прозрачности.',
        href: '/konverter-izobrazheniy',
      },
      {
        title: 'JPG/PNG -> WebP',
        description: 'Подготовить более компактную WebP-копию для сайта.',
        href: '/v-webp',
      },
      {
        title: 'Сжать изображение',
        description: 'Пересохранить PNG локально и проверить новый размер файла.',
        href: '/szhat-izobrazhenie',
      },
      {
        title: 'Изменить размер',
        description: 'Задать новую ширину и высоту с сохранением прозрачности.',
        href: '/izmenit-razmer-foto',
      },
    ],
    howTo: [
      'Выберите один PNG файл на устройстве или перетащите его в область загрузки.',
      'Рассмотрите изображение и прозрачные области на шахматном фоне, при необходимости измените масштаб.',
      'Проверьте имя, размер файла, габариты и формат, затем перейдите к конвертации, сжатию или изменению размера.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только PNG изображения.',
      too_large: 'Файл слишком большой. Максимальный размер — 50 MB.',
      too_large_image:
        'PNG слишком большой для открытия в браузере. Попробуйте изображение меньше 36 мегапикселей.',
      corrupt: 'PNG-сигнатура не найдена. Файл повреждён или имеет неверное расширение.',
      decode_failure:
        'Сигнатура PNG корректна, но браузер не смог декодировать изображение. Попробуйте пересохранить файл.',
    },
    faq: [
      {
        question: 'Как увидеть прозрачность PNG?',
        answer:
          'Прозрачные и полупрозрачные области показаны поверх шахматного фона, поэтому их можно отличить от белых пикселей изображения.',
      },
      {
        question: 'PNG отправляется на сервер?',
        answer:
          'Нет. Проверка формата, декодирование, предпросмотр и факты о файле выполняются локально в браузере.',
      },
      {
        question: 'Что можно сделать после просмотра?',
        answer:
          'Можно конвертировать PNG в JPG или WebP, сжать изображение либо изменить его ширину и высоту.',
      },
    ],
  },

  webpViewer: {
    eyebrow: 'Просмотр WebP',
    title: 'Открыть WebP онлайн',
    description:
      'Откройте WebP онлайн, рассмотрите изображение и проверьте имя, размер файла, габариты и формат. Всё работает локально без отправки файла на сервер.',
    acceptedFormats: 'WebP',
    dropTitle: 'Перетащите WebP сюда',
    dropDescription:
      'Выберите один WebP до 50 MB.',
    chooseFile: 'Выбрать WebP',
    loading: 'Открываем...',
    previewTitle: 'Предпросмотр WebP',
    previewAlt: 'Предпросмотр WebP изображения',
    dimensions: 'Габариты',
    relatedToolsTitle: 'Что сделать с WebP дальше',
    privacyNote:
      'Файл не отправляется на сервер. Проверка WebP, декодирование, предпросмотр и сохранение выполняются локально в браузере.',
    downloadJpg: 'Скачать JPG-копию',
    downloadPng: 'Скачать PNG-копию',
    exportingJpg: 'Готовим JPG...',
    exportingPng: 'Готовим PNG...',
    exportError:
      'Не удалось сохранить изображение в выбранном формате. Возможно, браузер не поддерживает такую операцию или ему не хватило памяти.',
    unsupportedBrowser:
      'Этот браузер не умеет декодировать WebP. Откройте файл в современном браузере; резервная обработка на сервере не используется.',
    staticFrameNote:
      'Для анимированного WebP сохраняется один статичный кадр. Анимация и метаданные не переносятся; JPG заменяет прозрачность белым фоном.',
    relatedTools: [
      {
        title: 'WebP в JPG или PNG',
        description: 'Открыть отдельный конвертер с выбором формата результата.',
        href: '/webp-v-jpg-png',
      },
      {
        title: 'Сжать изображение',
        description: 'Уменьшить вес WebP с локальной настройкой качества.',
        href: '/szhat-izobrazhenie',
      },
      {
        title: 'Изменить размер',
        description: 'Задать новую ширину и высоту изображения.',
        href: '/izmenit-razmer-foto',
      },
    ],
    howToTitle: 'Как пользоваться',
    howTo: [
      'Выберите один WebP файл на устройстве или перетащите его в область загрузки.',
      'Рассмотрите изображение, настройте масштаб или впишите его в область просмотра и проверьте имя, размер файла и габариты.',
      'При необходимости скачайте статичную JPG- или PNG-копию либо перейдите к конвертации, сжатию или изменению размера.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только WebP изображения.',
      too_large: 'Файл слишком большой. Максимальный размер — 50 MB.',
      too_large_image:
        'WebP слишком большой для открытия в браузере. Попробуйте изображение меньше 36 мегапикселей.',
      corrupt:
        'WebP-сигнатура не найдена. Файл повреждён или имеет неверное расширение.',
      decode_failure:
        'WebP-сигнатура корректна, но браузер не смог открыть файл. Он повреждён или использует неподдерживаемый вариант WebP.',
    },
    faq: [
      {
        question: 'Как открыть WebP онлайн?',
        answer:
          'Выберите файл с расширением .webp: браузер локально проверит формат и покажет изображение вместе с габаритами и размером файла.',
      },
      {
        question: 'WebP отправляется на сервер?',
        answer:
          'Нет. Файл декодируется и показывается прямо в браузере. Резервная обработка на сервере и загрузка файла не используются.',
      },
      {
        question: 'Можно ли сохранить WebP в JPG или PNG?',
        answer:
          'Да, после успешного открытия доступны дополнительные варианты сохранения средствами браузера. PNG сохраняет прозрачность, а JPG заменяет её белым фоном. Для анимации сохраняется один статичный кадр.',
      },
    ],
  },

  blurImage: {
    eyebrow: 'Приватность на фото',
    title: 'Размыть фото онлайн',
    description:
      'Загрузите JPG, PNG или WebP, вручную выделите прямоугольные области и закройте их размытием или пикселизацией. Файл обрабатывается локально в браузере.',
    formats: 'JPG, PNG, WebP',
    dropTitle: 'Перетащите изображение сюда',
    dropDescription:
      'Выберите JPG, PNG или WebP до 50 MB. После загрузки нарисуйте прямоугольники поверх областей, которые нужно скрыть.',
    chooseFile: 'Выбрать изображение',
    replaceImage: 'Заменить',
    settings: 'Области',
    modeLabel: 'Эффект',
    modes: [
      { key: 'blur', label: 'Размытие' },
      { key: 'pixelate', label: 'Пиксели' },
    ],
    strength: 'Сила эффекта',
    zones: 'Областей',
    noZones: 'Нарисуйте область на изображении',
    undoZone: 'Отменить',
    clearZones: 'Очистить',
    before: 'До',
    after: 'После',
    waitingPreview: 'Предпросмотр результата',
    notReady: 'Нарисуйте область',
    previewUpdating: 'Обновляем предпросмотр...',
    download: 'Скачать результат',
    exporting: 'Готовим файл...',
    manualNote:
      'Области выбираются вручную. Автоматического распознавания лиц и номеров нет.',
    privacyNote:
      'Файл не отправляется на сервер. Размытие и пикселизация выполняются прямо в браузере.',
    howTo: [
      'Выберите JPG, PNG или WebP файл на устройстве.',
      'Нарисуйте один или несколько прямоугольников поверх областей, которые нужно скрыть.',
      'Выберите размытие или пикселизацию, настройте силу эффекта и скачайте результат.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только JPG, PNG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeImage:
        'Изображение слишком большое для обработки в браузере. Попробуйте файл с меньшим разрешением.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для обработки.',
      unsupportedOutput:
        'Этот браузер не умеет сохранять результат в исходном формате WebP.',
      exportFailed: 'Не удалось подготовить изображение.',
      noImage: 'Сначала выберите изображение.',
      noZones: 'Сначала нарисуйте хотя бы одну область.',
    },
    faq: [
      {
        question: 'Файл отправляется на сервер?',
        answer:
          'Нет. Изображение открывается, обрабатывается и сохраняется прямо в браузере. Файл остаётся на вашем устройстве.',
      },
      {
        question: 'Есть автоматическое распознавание лиц?',
        answer:
          'Нет. В этой версии области нужно выделять вручную прямоугольниками: так результат полностью контролируется пользователем.',
      },
      {
        question: 'Что выбрать: размытие или пикселизацию?',
        answer:
          'Размытие мягче скрывает детали, а пикселизация делает область более явно закрытой. Силу эффекта можно менять перед скачиванием.',
      },
    ],
  },

  watermarkImage: {
    eyebrow: 'Текстовый watermark',
    title: 'Водяной знак на фото онлайн',
    description:
      'Загрузите JPG, PNG или WebP, добавьте текстовый водяной знак, настройте позицию, прозрачность, размер и поворот. Файл обрабатывается локально в браузере.',
    formats: 'JPG, PNG, WebP',
    dropTitle: 'Перетащите изображение сюда',
    dropDescription:
      'Выберите JPG, PNG или WebP до 50 MB. После загрузки настройте текст, положение, прозрачность, размер и формат результата.',
    chooseFile: 'Выбрать изображение',
    replaceImage: 'Заменить',
    settings: 'Водяной знак',
    textLabel: 'Текст',
    positionLabel: 'Позиция',
    opacityLabel: 'Прозрачность',
    sizeLabel: 'Размер',
    rotationLabel: 'Поворот',
    outputFormat: 'Формат результата',
    applyButton: 'Скачать с водяным знаком',
    retryDownload: 'Повторить скачивание',
    processing: 'Готовим файл...',
    sourceLabel: 'Исходник',
    resultLabel: 'Результат',
    waitingPreview: 'Предпросмотр watermark',
    emptyPreview: 'Текст',
    summary: 'Сводка',
    originalSize: 'Исходный файл',
    originalDimensions: 'Исходный размер',
    privacyNote:
      'Файл не отправляется на сервер. Изображение открывается и сохраняется прямо в браузере.',
    positions: [
      { key: 'top-left', label: 'Сверху слева' },
      { key: 'top-center', label: 'Сверху' },
      { key: 'top-right', label: 'Сверху справа' },
      { key: 'center', label: 'Центр' },
      { key: 'bottom-left', label: 'Снизу слева' },
      { key: 'bottom-center', label: 'Снизу' },
      { key: 'bottom-right', label: 'Снизу справа' },
    ],
    howTo: [
      'Выберите JPG, PNG или WebP файл на устройстве.',
      'Введите текст водяного знака, выберите позицию, прозрачность, размер и поворот.',
      'Выберите JPG, PNG или WebP для результата и скачайте файл одним действием.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только JPG, PNG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeImage:
        'Изображение слишком большое для обработки в браузере. Попробуйте файл с меньшим разрешением.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для водяного знака.',
      unsupportedOutput:
        'Этот браузер не умеет сохранять результат в выбранном формате WebP.',
      emptyText: 'Введите текст водяного знака.',
      exportFailed: 'Не удалось подготовить изображение с водяным знаком.',
    },
    faq: [
      {
        question: 'Фото отправляется на сервер?',
        answer:
          'Нет. Изображение открывается, водяной знак рисуется и результат сохраняется прямо в браузере. Файл остаётся на устройстве.',
      },
      {
        question: 'Можно настроить положение и вид водяного знака?',
        answer:
          'Да. Доступны семь позиций, прозрачность от 10% до 100%, размер текста и поворот от -45 до 45 градусов.',
      },
      {
        question: 'В каком формате можно скачать результат?',
        answer:
          'Можно выбрать JPG, PNG или WebP. JPG подходит для фото без прозрачности, PNG сохраняет прозрачность, WebP зависит от поддержки браузера.',
      },
    ],
    relatedTitle: 'Похожие инструменты',
    related: [
      {
        title: 'Размыть фото',
        description: 'Закройте области на изображении размытием или пикселизацией.',
        href: '/razmyt-foto',
      },
      {
        title: 'Изменить размер фото',
        description: 'Подготовьте фото нужной ширины и высоты перед публикацией.',
        href: '/izmenit-razmer-foto',
      },
      {
        title: 'Сжать изображение',
        description: 'Уменьшите вес готового файла после добавления watermark.',
        href: '/szhat-izobrazhenie',
      },
    ],
  },

  crop: {
    page: {
      eyebrow: 'Обрезать фото',
      title: 'Обрезать фото онлайн',
      description:
        'Загрузите JPG, PNG или WebP, выделите область и скачайте обрезанную картинку. Всё выполняется локально в браузере, без отправки файла на сервер.',
      faq: [
        {
          question: 'Файл отправляется на сервер?',
          answer:
            'Нет. Изображение открывается и обрезается в браузере. Файл не покидает ваше устройство.',
        },
        {
          question: 'Какие пропорции можно выбрать?',
          answer:
            'Доступны свободная обрезка, квадрат 1:1, 4:3, 16:9 и вертикальный 3:4. Область можно двигать и менять за углы.',
        },
        {
          question: 'В каком формате скачивается результат?',
          answer:
            'Результат сохраняется в исходном формате: JPG остаётся JPG, PNG остаётся PNG, WebP остаётся WebP.',
        },
      ],
    },
    formats: 'JPG, PNG, WebP',
    dropTitle: 'Перетащите изображение сюда',
    dropDescription:
      'Выберите JPG, PNG или WebP до 50 MB. После загрузки можно выделить область мышью или пальцем.',
    chooseFile: 'Выбрать изображение',
    replaceImage: 'Заменить',
    settings: 'Обрезка',
    aspectRatio: 'Соотношение сторон',
    width: 'Ширина',
    height: 'Высота',
    sourceLabel: 'Исходник',
    resultLabel: 'Обрезка',
    waitingPreview: 'Предпросмотр обрезки',
    notReady: 'Готовим предпросмотр',
    previewUpdating: 'Обновляем предпросмотр...',
    download: 'Скачать обрезанное',
    exporting: 'Готовим файл...',
    resizeHandle: 'Изменить область обрезки',
    privacyNote:
      'Файл не отправляется на сервер. Обрезка выполняется локально в браузере.',
    presets: [
      { key: 'free', label: 'Свободно', analyticsKey: 'free' },
      { key: 'square', label: '1:1', analyticsKey: '1_1' },
      { key: 'landscape', label: '4:3', analyticsKey: '4_3' },
      { key: 'wide', label: '16:9', analyticsKey: '16_9' },
      { key: 'portrait', label: '3:4', analyticsKey: '3_4' },
    ],
    howTo: [
      'Выберите JPG, PNG или WebP файл на устройстве.',
      'Выделите область обрезки и при необходимости выберите пропорцию.',
      'Нажмите кнопку скачивания, чтобы получить обрезанное изображение.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только JPG, PNG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для обрезки.',
      cropFailed: 'Не удалось обрезать изображение.',
      noImage: 'Сначала выберите изображение.',
    },
  },

  photo3x4: {
    page: {
      eyebrow: 'Фото 3x4',
      title: 'Фото 3x4 онлайн',
      description:
        'Загрузите JPG, PNG или WebP, выберите область кадра 3:4 и скачайте готовую картинку 300x400, 600x800 или в своём размере. Всё выполняется локально в браузере.',
      faq: [
        {
          question: 'Файл отправляется на сервер?',
          answer:
            'Нет. Фото открывается, обрезается и масштабируется в браузере. Файл не покидает ваше устройство.',
        },
        {
          question: 'Это официальный формат для паспорта или визы?',
          answer:
            'Нет. Страница делает изображение с пропорцией 3:4 и выбранным размером в пикселях, но не проверяет требования конкретного ведомства.',
        },
        {
          question: 'Можно выбрать другой размер?',
          answer:
            'Да. Есть пресеты 300x400 и 600x800, а в ручном режиме ширина и высота связаны пропорцией 3:4.',
        },
      ],
    },
    formats: 'JPG, PNG, WebP',
    dropTitle: 'Перетащите фото сюда',
    dropDescription:
      'Выберите JPG, PNG или WebP до 50 MB. После загрузки можно подвинуть рамку 3:4 и выбрать размер результата.',
    chooseFile: 'Выбрать фото',
    replaceImage: 'Заменить',
    settings: 'Фото 3x4',
    outputSize: 'Размер результата',
    width: 'Ширина',
    height: 'Высота',
    aspectLock: 'Пропорция 3:4 зафиксирована для кадра и результата.',
    backgroundColor: 'Фон для прозрачности',
    cropSize: 'Кадр',
    targetSize: 'Результат',
    previewTitle: 'Предпросмотр',
    sourceLabel: 'Исходный кадр',
    resultLabel: 'Фото 3x4',
    waitingPreview: 'После обработки',
    notReady: 'Не готово',
    previewUpdating: 'Обновляем предпросмотр...',
    processing: 'Готовим фото...',
    download: 'Скачать фото',
    retry: 'Повторить подготовку',
    resizeHandle: 'Изменить рамку 3x4',
    noComplianceNote:
      'Это не проверка официальных требований. Перед подачей документа сверяйте размер, фон и требования к лицу на сайте нужного ведомства.',
    privacyNote:
      'Файл не отправляется на сервер. Обрезка, фон и изменение размера выполняются локально в браузере.',
    presets: [
      { key: '300x400', label: '300x400' },
      { key: '600x800', label: '600x800' },
      { key: 'custom', label: 'Свой' },
    ],
    howTo: [
      'Выберите JPG, PNG или WebP файл на устройстве.',
      'Подвиньте рамку 3:4 и выберите размер результата 300x400, 600x800 или свой.',
      'Дождитесь актуального предпросмотр и скачайте готовое изображение одной кнопкой.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только JPG, PNG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeImage:
        'Изображение слишком большое для обработки в браузере. Попробуйте файл с меньшим разрешением.',
      tooLargeOutput: 'Размер результата слишком большой для обработки в браузере.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для фото 3x4.',
      unsupportedOutput:
        'Этот браузер не умеет сохранять результат в исходном формате WebP.',
      exportFailed: 'Не удалось подготовить фото 3x4.',
      noImage: 'Сначала выберите изображение.',
    },
  },

  resize: {
    page: {
      eyebrow: 'Изменить размер',
      title: 'Изменить размер фото онлайн',
      description:
        'Загрузите JPG, PNG или WebP, задайте новую ширину и высоту и скачайте уменьшенную картинку. Всё выполняется локально в браузере.',
      faq: [
        {
          question: 'Файл отправляется на сервер?',
          answer:
            'Нет. Изображение открывается, уменьшается и сохраняется прямо в браузере. Файл не покидает ваше устройство.',
        },
        {
          question: 'Можно сохранить исходные пропорции?',
          answer:
            'Да. Включите блокировку пропорций: при изменении ширины высота пересчитается автоматически, и наоборот.',
        },
        {
          question: 'В каком формате скачивается результат?',
          answer:
            'Результат сохраняется в исходном формате, если браузер поддерживает такой экспорт: JPG остаётся JPG, PNG остаётся PNG, WebP остаётся WebP.',
        },
      ],
    },
    formats: 'JPG, PNG, WebP',
    dropTitle: 'Перетащите изображение сюда',
    dropDescription:
      'Выберите JPG, PNG или WebP до 50 MB. После загрузки задайте новый размер или выберите быстрый пресет.',
    chooseFile: 'Выбрать изображение',
    replaceImage: 'Заменить',
    settings: 'Размер',
    presetsTitle: 'Пресет',
    width: 'Ширина',
    height: 'Высота',
    keepAspect: 'Сохранять пропорции',
    jpegQuality: 'Качество JPG',
    webpQuality: 'Качество WebP',
    previewUpdating: 'Обновляем предпросмотр...',
    processing: 'Готовим файл...',
    download: 'Скачать результат',
    retry: 'Повторить подготовку',
    before: 'До',
    after: 'После',
    waitingPreview: 'Предпросмотр результата',
    notReady: 'После обработки',
    summary: 'Сводка',
    originalSize: 'Исходный файл',
    targetSize: 'Новый размер',
    resultSize: 'После обработки',
    privacyNote:
      'Файл не отправляется на сервер. Изменение размера выполняется локально в браузере.',
    presets: [
      { key: '50', label: '50%' },
      { key: '25', label: '25%' },
      { key: 'custom', label: 'Свой' },
    ],
    howTo: [
      'Выберите JPG, PNG или WebP файл на устройстве.',
      'Укажите новую ширину и высоту, включите пропорции или выберите 50%/25%.',
      'Дождитесь актуального предпросмотр и скачайте готовое изображение одной кнопкой.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только JPG, PNG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeImage:
        'Изображение слишком большое для обработки в браузере. Попробуйте файл с меньшим разрешением.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для изменения размера.',
      unsupportedOutput:
        'Этот браузер не умеет сохранять результат в исходном формате WebP.',
      resizeFailed: 'Не удалось изменить размер изображения.',
      noImage: 'Сначала выберите изображение.',
    },
  },

  upscale: {
    page: {
      eyebrow: 'Увеличить изображение',
      title: 'Увеличить фото онлайн',
      description:
        'Загрузите JPG, PNG или WebP и увеличьте изображение в браузере. Инструмент меняет размер, но не дорисовывает детали.',
      faq: [
        {
          question: 'Это увеличение с нейросетью?',
          answer:
            'Нет. Страница использует локальное масштабирование с высоким сглаживанием. Оно увеличивает размер файла в пикселях, но не восстанавливает отсутствующие детали как нейросети.',
        },
        {
          question: 'Файл отправляется на сервер?',
          answer:
            'Нет. Изображение открывается, масштабируется и сохраняется прямо в браузере. Файл остаётся на вашем устройстве.',
        },
        {
          question: 'Когда такой инструмент полезен?',
          answer:
            'Он подходит, когда нужен файл большего размера для макета, печати небольшого изображения или загрузки в сервис с минимальным размером. Для сильного улучшения качества нужен отдельный AI/server workflow.',
        },
      ],
    },
    formats: 'JPG, PNG, WebP',
    dropTitle: 'Перетащите изображение сюда',
    dropDescription:
      'Выберите JPG, PNG или WebP до 50 MB. После загрузки выберите 2x, 3x, 4x или задайте свой размер до 4x.',
    chooseFile: 'Выбрать изображение',
    replaceImage: 'Заменить',
    settings: 'Увеличение',
    presetsTitle: 'Масштаб',
    width: 'Ширина',
    height: 'Высота',
    keepAspect: 'Сохранять пропорции',
    jpegQuality: 'Качество JPG',
    webpQuality: 'Качество WebP',
    upscaleButton: 'Увеличить',
    processing: 'Готовим файл...',
    download: 'Скачать результат',
    before: 'До',
    after: 'После',
    waitingPreview: 'После увеличения',
    notReady: 'После обработки',
    qualityNotice:
      'Метод: локальное масштабирование в браузере. Новые детали не появляются.',
    summary: 'Сводка',
    originalSize: 'Исходный файл',
    scaleLabel: 'Масштаб',
    targetSize: 'Новый размер',
    resultSize: 'После обработки',
    privacyNote:
      'Файл не отправляется на сервер. Увеличение выполняется локально средствами браузера.',
    presets: [
      { key: '2', label: '2x' },
      { key: '3', label: '3x' },
      { key: '4', label: '4x' },
      { key: 'custom', label: 'Свой' },
    ],
    howTo: [
      'Выберите JPG, PNG или WebP файл на устройстве.',
      'Выберите 2x, 3x, 4x или задайте ширину и высоту вручную.',
      'Нажмите кнопку увеличения и скачайте изображение большего размера.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только JPG, PNG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeImage:
        'Изображение слишком большое для обработки в браузере. Попробуйте файл с меньшим разрешением.',
      tooLargeOutput:
        'Размер результата слишком большой для обработки в браузере. Уменьшите масштаб или размер.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для увеличения.',
      unsupportedOutput:
        'Этот браузер не умеет сохранять результат в исходном формате WebP.',
      upscaleFailed: 'Не удалось увеличить изображение.',
      noImage: 'Сначала выберите изображение.',
    },
  },

  faviconGenerator: {
    eyebrow: 'Favicon package',
    title: 'Генератор favicon онлайн',
    description:
      'Загрузите PNG, JPG или WebP логотип, выберите вписать или обрезать квадрат и скачайте готовый favicon package для сайта.',
    dropTitle: 'Перетащите логотип сюда',
    dropDescription:
      'Выберите PNG, JPG или WebP до 50 MB. Генератор подготовит квадратные PNG 16, 32, 180, 192 и 512 px.',
    chooseFile: 'Выбрать изображение',
    replaceImage: 'Заменить',
    settings: 'Favicon',
    fitMode: 'Квадрат',
    fitModes: [
      { key: 'contain', label: 'Вписать' },
      { key: 'cover', label: 'Обрезать' },
    ],
    generateButton: 'Сгенерировать ZIP',
    processing: 'Готовим package...',
    downloadZip: 'Скачать ZIP',
    previewTitle: 'Предпросмотр кадрирования',
    outputPreviewTitle: 'Предпросмотр favicon',
    packageTitle: 'Файлы в ZIP',
    packageFiles: [
      'favicon-16x16.png',
      'favicon-32x32.png',
      'apple-touch-icon.png',
      'icon-192.png',
      'icon-512.png',
    ],
    privacyNote:
      'Файл не отправляется на сервер. Изображение открывается и масштабируется в браузере, ZIP собирается локально.',
    howTo: [
      'Выберите PNG, JPG или WebP изображение на устройстве.',
      'Выберите режим квадрата: вписать целиком или обрезать по центру.',
      'Нажмите кнопку генерации и скачайте ZIP с favicon PNG и site.webmanifest.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только PNG, JPG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeImage:
        'Изображение слишком большое для обработки в браузере. Попробуйте файл с меньшим разрешением.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для favicon.',
      packageFailed: 'Не удалось собрать favicon package.',
    },
    faq: [
      {
        question: 'Файл отправляется на сервер?',
        answer:
          'Нет. Изображение открывается, масштабируется и упаковывается в ZIP прямо в браузере. Файл остаётся на вашем устройстве.',
      },
      {
        question: 'Какие файлы будут в архиве?',
        answer:
          'ZIP содержит favicon-16x16.png, favicon-32x32.png, apple-touch-icon.png, icon-192.png, icon-512.png и site.webmanifest.',
      },
      {
        question: 'Чем отличаются режимы вписать и обрезать?',
        answer:
          'Вписать сохраняет всё изображение внутри квадрата с прозрачными полями. Обрезать заполняет весь квадрат и может срезать края.',
      },
    ],
  },

  converter: {
    page: {
      eyebrow: 'PNG ↔ JPG',
      title: 'Конвертер изображений PNG и JPG',
      description:
        'Конвертируйте PNG в JPG или JPG в PNG бесплатно. Выберите направление, настройте качество JPG и скачайте результат без отправки файлов на сервер.',
      howToTitle: 'Как конвертировать PNG и JPG',
      howTo: [
        'Выберите исходный формат PNG или JPG/JPEG.',
        'Добавьте изображения: формат определяется по содержимому файла.',
        'Для JPG настройте качество и запустите локальную конвертацию.',
        'Скачайте готовые изображения по одному или ZIP-архивом.',
      ],
      faq: [
        {
          question: 'Файлы отправляются на сервер?',
          answer:
            'Нет. PNG и JPG декодируются и конвертируются локально в вашем браузере.',
        },
        {
          question: 'Что происходит с прозрачностью PNG при конвертации в JPG?',
          answer:
            'JPG не поддерживает прозрачность, поэтому прозрачные области заполняются белым фоном.',
        },
        {
          question: 'Станет ли JPG лучше после конвертации в PNG?',
          answer:
            'Нет. PNG не добавит новых потерь, но не восстановит детали, уже потерянные при JPEG-сжатии.',
        },
        {
          question: 'Можно конвертировать несколько изображений сразу?',
          answer:
            'Да. Все файлы в одной очереди должны соответствовать выбранному исходному формату.',
        },
      ],
    },
    dropTitle: 'Перетащите изображения сюда',
    dropDescription: 'Выберите файлы {format}. Формат проверяется по содержимому, можно добавить несколько файлов сразу.',
    inputFormat: 'Исходный формат',
    chooseFiles: 'Выбрать файлы',
    clearAll: 'Очистить список',
    filesTitle: 'Файлы',
    downloadAll: 'Скачать все',
    settings: 'Настройки',
    outputFormat: 'Формат результата',
    recommended: 'Рекомендуется:',
    jpegCompact: 'JPEG (более компактный)',
    pngLossless: 'PNG (без потерь)',
    jpegDefault: 'JPEG',
    jpegQuality: 'Качество JPG',
    transparencyWarning: 'Прозрачные области PNG будут заполнены белым: JPG не поддерживает прозрачность.',
    pngQualityNote: 'PNG сохраняется без настройки качества. Конвертация не восстановит детали исходного JPG.',
    noFilesQueued: 'Нет файлов в очереди',
    summary: 'Сводка',
    pending: 'В очереди',
    done: 'Готово',
    errors: 'Ошибки',
    originalSize: 'Исходный размер',
    convertedSize: 'После конвертации',
    privacyNote: 'Файлы не отправляются на сервер. Конвертация выполняется в браузере.',
    errorsText: {
      canvas: 'Не удалось подготовить изображение',
      imageLoad: 'Не удалось загрузить изображение',
      conversion: 'Ошибка конвертации изображения',
      generic: 'Ошибка конвертации',
      unsupported: 'Поддерживаются только настоящие PNG, JPG и JPEG файлы.',
      wrongDirection: 'Формат файла не совпадает с выбранным исходным форматом.',
      tooLarge: 'Файл превышает лимит 50 МБ.',
      invalidContainer: 'Файл повреждён или содержит неполный контейнер изображения.',
      tooManyPixels: 'Изображение превышает лимит 36 мегапикселей или 16 384 пикселя по стороне.',
      tooManyFiles: 'В одной очереди можно обработать не более 20 файлов.',
      aggregateInputTooLarge: 'Суммарный размер файлов в очереди превышает 200 МБ.',
      aggregatePixelsTooLarge: 'Суммарный размер изображений в очереди превышает 144 мегапикселя.',
      outputZipWorkloadTooLarge: 'Очередь слишком велика для безопасной подготовки результатов и ZIP-архива.',
    },
  },

  imageToWebp: {
    eyebrow: 'JPG и PNG в WebP',
    title: 'Конвертер JPG и PNG в WebP',
    description:
      'Конвертируйте JPG, JPEG и PNG в WebP онлайн бесплатно. Файлы обрабатываются локально в браузере, можно настроить качество и сравнить размер до скачивания.',
    dropTitle: 'Перетащите JPG или PNG сюда',
    dropDescription:
      'Выберите JPG, JPEG или PNG до 50 MB. Можно добавить несколько файлов, посмотреть WebP-результат и скачать всё ZIP-архивом.',
    chooseFiles: 'Выбрать изображения',
    qualityLabel: 'Качество WebP',
    sourceLabel: 'Исходник',
    resultLabel: 'WebP',
    privacyNote:
      'Файлы не отправляются на сервер. Изображение открывается и сохраняется в WebP средствами браузера.',
    qualityHowTo: 'выберите баланс размера и качества WebP',
    errorsText: {
      unsupported: 'Поддерживаются только JPG, JPEG и PNG изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      unsupportedWebp:
        'Этот браузер не умеет сохранять изображения в WebP. Попробуйте обновить браузер или используйте другой.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для WebP.',
      conversion: 'Не удалось конвертировать изображение в WebP.',
      generic: 'Ошибка конвертации в WebP',
    },
    faq: [
      {
        question: 'Файлы отправляются на сервер?',
        answer:
          'Нет. JPG и PNG открываются и кодируются в WebP прямо в браузере. Файлы остаются на вашем устройстве.',
      },
      {
        question: 'Что делает ползунок качества?',
        answer:
          'Чем ниже качество, тем обычно меньше файл и заметнее потери деталей.',
      },
      {
        question: 'Можно конвертировать несколько файлов сразу?',
        answer:
          'Да. Добавьте несколько JPG или PNG файлов, сконвертируйте их в WebP и скачайте по одному или одним ZIP-архивом.',
      },
    ],
  },

  webpConverter: {
    eyebrow: 'WebP в JPG и PNG',
    title: 'Конвертер WebP в JPG и PNG',
    description:
      'Конвертируйте WebP в JPG или PNG онлайн бесплатно. Файлы обрабатываются локально в браузере, можно выбрать формат результата, настроить качество JPG и скачать всё ZIP-архивом.',
    dropTitle: 'Перетащите WebP сюда',
    dropDescription:
      'Выберите WebP файлы до 50 MB. Можно добавить несколько изображений, посмотреть результат и скачать JPG/PNG по одному или архивом.',
    chooseFiles: 'Выбрать WebP',
    outputFormat: 'Формат результата',
    qualityLabel: 'Качество JPG',
    qualityHint:
      'Для прозрачных WebP при сохранении в JPG прозрачные области заполняются белым фоном.',
    pngHint:
      'PNG сохраняется без потерь и поддерживает прозрачность, но итоговый файл может быть крупнее исходного WebP.',
    sourceLabel: 'WebP',
    resultLabel: 'Результат',
    oppositeLabel: 'Нужно наоборот: JPG/PNG в WebP',
    privacyNote:
      'Файлы не отправляются на сервер. WebP открывается и сохраняется в JPG или PNG средствами браузера.',
    qualityHowTo: 'выберите качество JPG от 10% до 100%',
    pngHowTo: 'сохраните PNG без настройки качества',
    errorsText: {
      unsupported: 'Поддерживаются только WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      corrupt: 'Не удалось открыть WebP. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для конвертации WebP.',
      conversion: 'Не удалось конвертировать WebP.',
      generic: 'Ошибка конвертации WebP',
    },
    faq: [
      {
        question: 'Файлы отправляются на сервер?',
        answer:
          'Нет. WebP открывается и пересохраняется прямо в браузере. Файлы остаются на вашем устройстве.',
      },
      {
        question: 'Что выбрать: JPG или PNG?',
        answer:
          'JPG обычно меньше и подходит для фотографий. PNG сохраняет прозрачность и удобен для графики, но может весить больше.',
      },
      {
        question: 'Можно конвертировать несколько WebP сразу?',
        answer:
          'Да. Добавьте несколько WebP файлов, выберите JPG или PNG и скачайте результаты по одному или одним ZIP-архивом.',
      },
    ],
  },

  avifConverter: {
    eyebrow: 'AVIF локально',
    title: 'AVIF конвертер онлайн',
    description:
      'Конвертируйте JPG, PNG и WebP в AVIF или сохраните AVIF как JPG/PNG. Файл обрабатывается локально в браузере.',
    dropTitle: 'Перетащите изображение сюда',
    dropDescription:
      'Выберите AVIF, JPG, PNG или WebP до 50 MB. Поддержка AVIF зависит от текущего браузера и проверяется во время конвертации.',
    chooseFile: 'Выбрать изображение',
    replaceFile: 'Заменить изображение',
    outputFormat: 'Формат результата',
    avifQualityLabel: 'Качество AVIF',
    jpegQualityLabel: 'Качество JPG',
    sourceLabel: 'Исходник',
    resultLabel: 'Результат',
    waitingSource: 'Выберите файл',
    waitingResult: 'После конвертации',
    privacyNote:
      'Файл не отправляется на сервер. AVIF открывается и сохраняется средствами браузера. Если браузер не умеет сохранять AVIF, появится понятная ошибка.',
    qualityHowTo: 'выберите формат результата и качество для AVIF или JPG',
    errorsText: {
      unsupported: 'Поддерживаются только AVIF, JPG, PNG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      unsupportedAvifDecode:
        'Этот браузер не смог открыть AVIF-файл. Попробуйте обновить браузер или сохранить файл в другом формате.',
      unsupportedAvifEncode:
        'Этот браузер не умеет сохранять AVIF. Выберите JPG/PNG или попробуйте другой браузер.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для конвертации.',
      conversion: 'Не удалось конвертировать изображение.',
      generic: 'Ошибка AVIF-конвертации',
    },
    faq: [
      {
        question: 'Файл отправляется на сервер?',
        answer:
          'Нет. Изображение открывается и сохраняется прямо в браузере. Сервер не используется.',
      },
      {
        question: 'Почему AVIF может не сохраниться?',
        answer:
          'Сохранение в AVIF зависит от поддержки в браузере. Если её нет, можно выбрать JPG или PNG.',
      },
      {
        question: 'Можно открыть AVIF и сохранить в обычный формат?',
        answer:
          'Да, если браузер декодирует AVIF upload. Выберите результат JPG или PNG и скачайте конвертированную копию.',
      },
    ],
  },

  tiffToJpg: {
    eyebrow: 'TIFF в JPG',
    title: 'Конвертер TIFF в JPG онлайн',
    description:
      'Конвертируйте TIFF и TIF изображения в JPG бесплатно. Декодирование выполняется локально через UTIF.js, результат сохраняется без отправки файла на сервер.',
    dropTitle: 'Перетащите TIFF сюда',
    dropDescription:
      'Выберите TIFF или TIF до 50 MB. Можно добавить несколько файлов и скачать JPG по одному или ZIP-архивом.',
    chooseFiles: 'Выбрать TIFF',
    qualityLabel: 'Качество JPG',
    multiPageWarning:
      'В этом TIFF несколько страниц или кадров. В JPG сохранён первый кадр; остальные страницы не переносятся.',
    privacyNote:
      'Файлы не отправляются на сервер. TIFF декодируется локально через UTIF.js, загружаемый только на этой странице, а JPG создаётся.',
    qualityHowTo: 'выберите баланс размера и качества JPG',
    errorsText: {
      unsupported: 'Поддерживаются только TIFF и TIF файлы.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeImage:
        'Изображение слишком большое для обработки в браузере. Попробуйте TIFF с меньшим разрешением.',
      noImages:
        'В TIFF не найдено растровое изображение. Файл может содержать только metadata или неподдерживаемую структуру.',
      corrupt:
        'Не удалось открыть TIFF. Возможно, файл повреждён или использует неподдерживаемый вариант формата.',
      invalidSignature: 'У файла нет корректной сигнатуры TIFF.',
      unsupportedVariant: 'Это сжатие или layout TIFF не поддерживается для безопасной обработки в браузере.',
      decode: 'Не удалось декодировать TIFF в браузере.',
      memory: 'Для этого TIFF браузеру требуется слишком много памяти.',
      canvas: 'Не удалось подготовить изображение для TIFF.',
      conversion: 'Не удалось конвертировать TIFF в JPG.',
      generic: 'Ошибка конвертации TIFF',
    },
    faq: [
      {
        question: 'Файлы отправляются на сервер?',
        answer:
          'Нет. TIFF декодируется и сохраняется в JPG прямо в браузере. Файл остаётся на вашем устройстве.',
      },
      {
        question: 'Почему сохраняется только первый кадр?',
        answer:
          'Страница делает простой перевод TIFF в JPG. Если TIFF содержит несколько страниц или кадров, страница предупредит об этом и сохранит первый кадр.',
      },
      {
        question: 'Какие TIFF поддерживаются?',
        answer:
          'Принимаются несжатые TIFF с распространёнными 8-битными схемами grayscale, RGB, RGBA, palette и CMYK. Сжатые варианты LZW, PackBits, JPEG и CCITT отклоняются для безопасной локальной обработки.',
      },
    ],
  },

  removeExif: {
    eyebrow: 'Приватность фото',
    title: 'Удалить EXIF и метаданные фото онлайн',
    description:
      'Удалите распознаваемые EXIF/XMP, текстовые поля и время из JPG, PNG или WebP. Файл обрабатывается локально в браузере и не отправляется на сервер.',
    dropTitle: 'Перетащите фото сюда',
    dropDescription:
      'Выберите один JPG, PNG или WebP до 50 MB. Неизвестные и проприетарные блоки могут остаться.',
    chooseFile: 'Выбрать фото',
    replaceFile: 'Заменить фото',
    inspecting: 'Проверяем файл...',
    processing: 'Удаляем метаданные...',
    cleanButton: 'Удалить метаданные',
    previewTitle: 'Фото и очищенная копия',
    sourceLabel: 'Исходник',
    resultLabel: 'Очищенная копия',
    waitingPreview: 'После очистки',
    doneStatus: 'Поддерживаемые метаданные удалены, файл готов к скачиванию',
    summary: 'Сводка',
    metadataLabel: 'Поддерживаемые метаданные',
    metadataYes: 'Найден',
    metadataNo: 'Не найден',
    metadataLabels: {
      exif: 'EXIF',
      xmp: 'XMP',
      text: 'Текстовые поля',
      time: 'Время изменения',
      colorProfile: 'Цветовой профиль ICC',
    },
    colorProfilePreserved: 'Сохранён',
    jpegLossyNote:
      'JPG пересохраняется с качеством 95%. Это сжатие с потерями: размер и отдельные пиксельные значения могут измениться.',
    originalSize: 'Исходный размер',
    cleanedSize: 'После очистки',
    privacyNote:
      'Файл не отправляется на сервер. Это не forensic-очистка: неизвестные и проприетарные блоки могут остаться. Инструмент не даёт юридической или compliance-гарантии.',
    howTo: [
      'Выберите JPG, PNG или WebP на устройстве.',
      'Проверьте найденные типы метаданных и сохранение ICC-профиля.',
      'Нажмите кнопку удаления и скачайте очищенную копию.',
    ],
    errorsText: {
      unsupported:
        'Поддерживаются только JPG, JPEG, PNG и WebP.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeDimensions:
        'Изображение слишком большое. Максимум — 36 мегапикселей и 32768 пикселей по стороне.',
      corrupt: 'Не удалось проверить изображение. Возможно, контейнер повреждён.',
      canvas: 'Не удалось подготовить изображение для очистки EXIF.',
      cleanup: 'Не удалось создать очищенную копию.',
    },
    faq: [
      {
        question: 'Файл отправляется на сервер?',
        answer:
          'Нет. Проверка и очистка выполняются в браузере. Файл остаётся на вашем устройстве.',
      },
      {
        question: 'Что именно удаляется?',
        answer:
          'Для JPG удаляются метаданные при создании новой JPG-копии. Для PNG удаляются eXIf, tEXt, zTXt, iTXt и tIME; для WebP — EXIF и XMP. При контейнерной очистке PNG/WebP ICC-профиль и данные изображения сохраняются. JPEG пересохраняется, поэтому сохранение ICC-профиля не гарантируется.',
      },
      {
        question: 'Удаляются ли все следы и скрытые данные?',
        answer:
          'Нет. Неизвестные и проприетарные блоки могут остаться. Это не forensic-инструмент и не юридическая или compliance-гарантия.',
      },
    ],
  },

  physicalPhotoSize: {
    eyebrow: 'Размер печати и PPI',
    title: 'Размер фото в сантиметрах и PPI',
    description:
      'Узнайте размеры изображения в пикселях, проверьте записанную плотность и рассчитайте предполагаемый размер печати в сантиметрах, миллиметрах и дюймах.',
    dropTitle: 'Перетащите одно фото сюда',
    dropDescription:
      'Статический JPG, PNG или WebP до 50 MB, 36 MP и 32 768 px по стороне. APNG и animated WebP не принимаются.',
    chooseFile: 'Выбрать фото',
    inspecting: 'Проверяем фото...',
    cancel: 'Отменить',
    reset: 'Открыть другое',
    pixelsTitle: 'Размер в пикселях',
    pixelsDescription: 'Пиксели описывают сетку изображения, но сами по себе не задают сантиметры.',
    densityTitle: 'Плотность в файле',
    states: {
      found: 'PPI найден',
      not_recorded: 'Не записано',
      aspect_ratio_only: 'Только соотношение пикселей',
      asymmetric: 'X и Y различаются',
      conflicting_sources: 'Источники конфликтуют',
      unsupported_metadata_source: 'Не удалось подтвердить',
    },
    stateDescriptions: {
      found: 'Найден один согласованный источник с физической единицей.',
      not_recorded: 'Подтверждённой записи плотности нет. Значение по умолчанию не подставляется.',
      aspect_ratio_only: 'Записано отношение X/Y без дюймов или сантиметров — это не PPI.',
      asymmetric: 'Плотность по X и Y различается. Значения не усредняются.',
      conflicting_sources: 'Несколько unit-bearing источников сообщают разные значения. Ни один не выбран молча.',
      unsupported_metadata_source: 'Есть повреждённый или неподдержанный источник плотности, поэтому отсутствие PPI не утверждается.',
    },
    sourcesTitle: 'Исходные записи metadata',
    noSources: 'JFIF, Exif или pHYs с плотностью не найдены.',
    source: 'Источник',
    unit: 'Единица',
    sourceNames: {
      jfif: 'JPEG JFIF',
      exif: 'JPEG Exif',
      png_phys: 'PNG pHYs',
      png_exif: 'PNG eXIf',
      webp_exif: 'WebP Exif',
      xmp: 'Неподдержанный metadata source',
    },
    units: {
      ppi: 'на дюйм',
      ppcm: 'на сантиметр',
      ppm: 'пикселей на метр',
      unitless: 'без физической единицы',
      invalid: 'не удалось подтвердить',
    },
    asymmetricWarning:
      'X и Y показаны отдельно: это может означать non-square pixels или несогласованную metadata. Для расчёта можно явно выбрать свой PPI.',
    conflictWarning:
      'Источники не согласуются. Автоматический размер не рассчитывается, пока вы явно не выберете PPI.',
    ppiTitle: 'PPI для расчёта',
    ppiDescription:
      'PPI — pixels per inch изображения. DPI описывает dots per inch печатающего устройства; разговорный запрос «DPI фото» здесь переводится в PPI.',
    customPpi: 'Свой PPI от 1 до 2400',
    apply: 'Применить',
    useMetadata: 'Вернуть значение файла',
    userSelected: 'Используется выбранный вами PPI. Он не выдаётся за найденный в файле.',
    detected: 'Используется подтверждённый PPI из файла.',
    choosePpi: 'Выберите 72, 96, 150, 300, 600 PPI или введите своё значение.',
    sizeTitle: 'Предполагаемый физический размер',
    formula: 'Дюймы = пиксели / PPI; сантиметры = дюймы × 2,54; миллиметры = дюймы × 25,4.',
    centimeters: 'Сантиметры',
    millimeters: 'Миллиметры',
    inches: 'Дюймы',
    calculationNote:
      'Изменение metadata само по себе не добавляет деталей и не меняет качество. Resampling меняет пиксельную сетку и может изменить резкость, байты и качество.',
    related: [
      { href: '/izmenit-razmer-foto', title: 'Изменить пиксели', description: 'Меняет ширину и высоту raster grid, а не только расчёт размера печати.' },
      { href: '/posmotret-exif', title: 'Посмотреть EXIF', description: 'Показывает более широкий набор метаданных, камеры и полей с личными данными.' },
      { href: '/udalit-exif', title: 'Удалить EXIF', description: 'Создаёт отдельную очищенную копию вместо read-only проверки.' },
    ],
    howToTitle: 'Как узнать размер фото в сантиметрах',
    howTo: [
      'Выберите один статический JPG, PNG или WebP на устройстве.',
      'Проверьте пиксели, источник и состояние записанной плотности.',
      'Используйте подтверждённый PPI или явно выберите свой и прочитайте размер в трёх единицах.',
    ],
    errors: {
      unsupported: 'Поддерживаются только статические JPG/JPEG, PNG и WebP.',
      tooLarge: 'Файл превышает лимит 50 MB.',
      dimensions: 'Изображение превышает 36 MP или 32 768 px по стороне.',
      animated: 'APNG и animated WebP не поддерживаются. Выберите один статический кадр.',
      invalid: 'Контейнер повреждён, обрезан или имеет несогласованную структуру.',
      failed: 'Не удалось безопасно проверить изображение в этом браузере.',
      ppi: 'Введите конечное значение PPI от 1 до 2400.',
    },
    faq: [
      { question: 'DPI и PPI фото — одно и то же?', answer: 'Нет. PPI — pixels per inch изображения и расчёта. DPI — dots per inch печатающего устройства. В разговорном запросе «DPI фото» обычно ищут именно записанный PPI.' },
      { question: 'Если PPI не записан, сервис подставит 72 или 96?', answer: 'Нет. Значение по умолчанию не придумывается: выберите preset или введите PPI явно.' },
      { question: 'Изменится ли качество фото?', answer: 'Нет. Инструмент ничего не сохраняет и не меняет. Metadata-only change не добавляет деталей; resampling — отдельная операция, которая меняет пиксели.' },
      { question: 'Фото отправляется на сервер?', answer: 'Нет. Файл обрабатывается в браузере и остаётся на устройстве. Аналитика получает только факт запуска, успеха или ошибки без имени, размеров, PPI и метаданных.' },
    ],
  },

  metadataViewer: {
    eyebrow: 'Проверка приватности фото',
    title: 'Посмотреть EXIF и метаданные фото онлайн',
    description:
      'Проверьте EXIF, IPTC, XMP и чувствительные поля JPG, TIFF или HEIC локально в браузере. Файл и найденные данные не отправляются на сервер.',
    dropTitle: 'Перетащите фото сюда',
    dropDescription:
      'Выберите один JPG, TIFF или HEIC до 50 MB. Поддержка зависит от контейнера: для HEIC XMP и IPTC не читаются и отмечаются честно.',
    chooseFile: 'Выбрать фото',
    inspecting: 'Читаем метаданные...',
    cancel: 'Отменить проверку',
    reset: 'Открыть другое',
    resultsTitle: 'Найденные метаданные',
    formatLabel: 'Формат',
    available: 'Найдено',
    notFound: 'Не найдено',
    unsupported: 'Не поддерживается',
    noMetadata: 'Распознаваемых полей нет. Это не доказывает отсутствие неизвестных или проприетарных блоков.',
    copyJson: 'Копировать JSON',
    copied: 'JSON скопирован',
    privacyTitle: 'Личные данные',
    noPrivacyFlags: 'В распознаваемых полях не найдено отмеченных личных данных.',
    openMap: 'Открыть координаты на карте',
    removeExifCta: 'Удалить EXIF из копии',
    privacyNote:
      'Координаты не запрашиваются у карт и не покидают браузер, пока вы явно не нажмёте ссылку. Инструмент не подтверждает достоверность данных и не является forensic-анализом.',
    groups: {
      camera: 'Камера и съёмка',
      date: 'Дата и время',
      orientation: 'Ориентация',
      gps: 'GPS и местоположение',
      serial: 'Серийные номера и автор',
      software: 'ПО и обработка',
      thumbnail: 'Встроенная миниатюра',
      other: 'Другие распознанные поля',
    },
    privacyFlags: {
      gps: 'Найдены координаты или данные местоположения',
      serial: 'Найден серийный номер, владелец или автор',
      software: 'Найдены сведения о ПО или прошивке',
      embedded_thumbnail: 'В файл встроена отдельная миниатюра',
    },
    howTo: [
      'Выберите JPG, TIFF или HEIC до 50 MB.',
      'Проверьте группы полей и отмеченные личные данные.',
      'Скопируйте JSON или перейдите к удалению EXIF из отдельной копии.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только JPG/JPEG, TIFF/TIF и HEIC/HEIF.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      invalid: 'Не удалось прочитать контейнер. Файл повреждён или использует неподдерживаемый вариант.',
      failed: 'Не удалось безопасно прочитать метаданные в браузере.',
      copy: 'Не удалось скопировать JSON. Выделите данные вручную или разрешите доступ к буферу обмена.',
    },
    faq: [
      {
        question: 'Файл и метаданные отправляются на сервер?',
        answer:
          'Нет. Разбор выполняется локально в браузере. В аналитику уходят только события запуска, успеха или ошибки без имени файла, координат и содержимого.',
      },
      {
        question: 'Какие форматы метаданных поддерживаются?',
        answer:
          'JPG и TIFF проверяются на EXIF/GPS, IPTC и XMP. Для HEIC читаются подтверждённые EXIF/GPS; XMP и IPTC помечаются как неподдерживаемые, а не как отсутствующие.',
      },
      {
        question: 'Это гарантирует отсутствие скрытых данных?',
        answer:
          'Нет. Неизвестные и проприетарные блоки могут остаться незамеченными. Инструмент показывает распознанные поля, но не является антивирусом или forensic-проверкой.',
      },
    ],
  },


  compressImage: {
    eyebrow: 'Сжатие изображений',
    title: 'Сжать изображение онлайн',
    description:
      'Загрузите JPG или WebP, настройте качество либо лимит файла и скачайте результат. PNG доступен для честного повторного сохранения. Всё работает локально без отправки изображений на сервер.',
    formats: 'JPG, PNG, WebP',
    dropTitle: 'Перетащите изображения сюда',
    dropDescription:
      'Выберите JPG, PNG или WebP до 50 MB. Можно добавить несколько файлов, сравнить размер до и после и скачать всё ZIP-архивом.',
    chooseFiles: 'Выбрать изображения',
    compressButton: 'Сжать',
    updatePreviewButton: 'Обновить предпросмотр',
    compressing: 'Сжимаем...',
    modeLabel: 'Режим сжатия',
    qualityMode: 'По качеству',
    targetMode: 'До заданного размера',
    qualityLabel: 'Качество JPG/WebP',
    qualityHint:
      'Ползунок влияет на JPG и WebP. Чем ниже качество, тем обычно меньше файл.',
    targetPresetLabel: 'Лимит файла',
    customTarget: 'Свой',
    targetValueLabel: 'Заданный размер',
    targetHint:
      'Для JPG и WebP браузер ограниченно подбирает качество и при необходимости уменьшает габариты. Внешний вид может измениться.',
    invalidTarget: 'Укажите размер от 10 KB до 50 MB.',
    pngOnlyHint:
      'В списке только PNG: браузер выполнит повторное сохранение без настройки качества.',
    pngNotice:
      'PNG сохраняется без потерь. Если исходный PNG уже оптимизирован, файл может почти не уменьшиться или стать немного больше.',
    pngNoSavings:
      'Экономии для этого PNG нет: браузерное повторное сохранение не всегда уменьшает уже оптимизированные PNG.',
    pngTargetNotice:
      'Для PNG точный лимит недоступен: файл будет только повторно сохранён без потерь и без отметки о достижении заданного размера.',
    sourceLabel: 'До',
    resultLabel: 'После',
    waitingPreview: 'После сжатия',
    originalSize: 'Исходный размер',
    compressedSize: 'После сжатия',
    actualQuality: 'Фактическое качество',
    targetReached: 'Лимит достигнут',
    bestFound: 'Лучший найденный результат',
    downloadBest: 'Скачать лучший',
    targetUnreachable:
      'Цель недостижима при минимальном качестве и минимальной длинной стороне 320 px. Показан фактический минимум в поддерживаемых границах.',
    targetAttemptLimit:
      'Поиск остановлен по лимиту попыток. Показан лучший найденный результат, а не доказанный минимум.',
    targetTimeLimit:
      'Поиск остановлен по безопасному временному бюджету. Показан лучший найденный результат, а не доказанный минимум.',
    privacyNote:
      'Файлы не отправляются на сервер. JPG, PNG и WebP открываются и сохраняются средствами браузера.',
    qualityHowTo:
      'выберите баланс размера и качества для JPG/WebP; PNG сохраняется без отдельного качества',
    errorsText: {
      unsupported: 'Поддерживаются только JPG, PNG и WebP изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooLargeImage:
        'Изображение слишком большое для обработки в браузере. Максимум — 36 мегапикселей и 32768 px по стороне.',
      unsupportedWebp:
        'Этот браузер не умеет сохранять WebP. Попробуйте обновить браузер или используйте другой.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      canvas: 'Не удалось подготовить изображение для сжатия.',
      compression: 'Не удалось сжать изображение.',
      invalidTarget: 'Укажите корректный лимит файла.',
      generic: 'Ошибка сжатия изображения',
    },
    howToTitle: 'Как сжать изображение',
    howTo: [
      'Выберите один или несколько JPG, PNG или WebP до 50 MB.',
      'Оставьте ручное качество или выберите режим до заданного размера и лимит в KB/MB.',
      'Проверьте фактический размер, качество и габариты результата, затем скачайте файл или ZIP.',
    ],
    faq: [
      {
        question: 'Файлы отправляются на сервер?',
        answer:
          'Нет. Изображения открываются и пересохраняются локально в браузере. Файлы остаются на вашем устройстве.',
      },
      {
        question: 'Всегда ли получится точный заданный размер?',
        answer:
          'Нет. Успех показывается только когда JPG или WebP не превышает лимит. Поиск может снизить качество и габариты; если даже минимальные границы не помогают, страница честно покажет фактический минимум.',
      },
      {
        question: 'Почему для PNG нет режима точного размера?',
        answer:
          'Браузер сохраняет PNG без настройки качества. Поэтому PNG повторно сохраняется без потерь, но не получает ложную отметку о достижении лимита.',
      },
      {
        question: 'Можно сжать несколько файлов сразу?',
        answer:
          'Да. Добавьте несколько JPG, PNG или WebP файлов и скачайте результаты по одному или одним ZIP-архивом.',
      },
    ],
  },

  svgConverter: {
    eyebrow: 'SVG в PNG/JPG',
    title: 'Конвертер SVG в PNG и JPG',
    description:
      'Загрузите SVG, выберите PNG или JPG, оставьте исходный размер или задайте ширину и высоту. Обработка выполняется локально в браузере.',
    dropTitle: 'Перетащите SVG сюда',
    dropDescription:
      'Выберите один SVG до 10 MB. Перед показом файл проверяется на scripts, external resources и неподдерживаемые вставки.',
    chooseFile: 'Выбрать SVG',
    replaceFile: 'Заменить SVG',
    maxFileSize: 'До 10 MB',
    settings: 'Конвертация',
    outputFormat: 'Формат результата',
    keepOriginalSize: 'Исходный размер',
    keepAspect: 'Сохранять пропорции',
    width: 'Ширина',
    height: 'Высота',
    backgroundColor: 'Фон JPG',
    convert: 'Конвертировать',
    processing: 'Готовим файл...',
    download: 'Скачать результат',
    sourceLabel: 'SVG',
    resultLabel: 'Результат',
    waitingPreview: 'После конвертации',
    notReady: 'Не готово',
    summary: 'Сводка',
    originalSize: 'Исходный файл',
    targetSize: 'Размер результата',
    resultSize: 'После конвертации',
    privacyNote:
      'Файл не отправляется на сервер. SVG валидируется как XML, опасные конструкции блокируются, затем безопасная копия отрисовывается в браузере.',
    howTo: [
      'Выберите один SVG файл на устройстве.',
      'Выберите PNG или JPG, оставьте исходный размер или задайте ширину и высоту.',
      'Нажмите кнопку конвертации и скачайте готовое растровое изображение.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только SVG файлы.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 10 MB.',
      invalidSvg: 'Не удалось прочитать SVG. Проверьте, что это корректный XML/SVG файл.',
      unsafeSvg:
        'SVG содержит scripts, event handlers или другие небезопасные конструкции. Такой файл не обрабатывается.',
      externalResource:
        'SVG ссылается на внешние ресурсы или CSS imports. Для локальной безопасной конвертации используйте self-contained SVG.',
      unsupportedSvg:
        'Браузер не смог отрисовать этот SVG. Возможно, файл использует неподдерживаемые SVG/CSS возможности.',
      canvas: 'Не удалось подготовить изображение для такого размера результата.',
      conversion: 'Не удалось конвертировать SVG.',
    },
    faq: [
      {
        question: 'Файл отправляется на сервер?',
        answer:
          'Нет. SVG читается, проверяется и отрисовывается прямо в браузере. Файл не покидает устройство.',
      },
      {
        question: 'Почему некоторые SVG не открываются?',
        answer:
          'Для безопасности блокируются скрипты, обработчики событий, foreignObject, внешние картинки, шрифты и CSS-импорты. Часть сложных SVG/CSS возможностей браузер canvas также может не поддержать.',
      },
      {
        question: 'Что происходит с прозрачностью при JPG?',
        answer:
          'JPG не поддерживает прозрачность, поэтому прозрачные области заполняются выбранным фоном. Для прозрачности скачивайте PNG.',
      },
    ],
  },

  heicViewer: {
    howToTitle: 'Как пользоваться',
    eyebrow: 'Просмотр HEIC',
    title: 'Открыть HEIC онлайн',
    description:
      'Откройте один HEIC или HEIF файл онлайн и посмотрите фото прямо в браузере. Копию можно скачать в JPG или PNG.',
    acceptedFormats: 'HEIC, HEIF',
    dropTitle: 'Перетащите HEIC или HEIF, чтобы открыть',
    dropDescription: 'Выберите один HEIC или HEIF до 50 MB.',
    chooseFile: 'Открыть HEIC/HEIF',
    loading: 'Открываем...',
    previewTitle: 'HEIC открыт в браузере',
    previewAlt: 'Предпросмотр HEIC',
    dimensions: 'Габариты',
    downloadJpg: 'Скачать копию JPG',
    downloadPng: 'Скачать копию PNG',
    exportingJpg: 'Готовим JPG...',
    exportingPng: 'Готовим PNG...',
    multiFrameWarning:
      'В этом HEIC/HEIF несколько кадров. В просмотре и копиях используется первый кадр, видео из Live Photo не переносится.',
    privacyNote:
      'Файл не отправляется на сервер. HEIC декодируется прямо в браузере, там же создаются копии JPG и PNG.',
    relatedToolsTitle: 'Другие действия с HEIC',
    relatedTools: [
      {
        title: 'HEIC в JPG, PNG или WebP',
        description: 'Конвертировать до 10 файлов с выбором формата.',
        href: '/heic-v-jpg',
      },
      {
        title: 'Сжать изображение',
        description: 'Уменьшить вес JPG-копии.',
        href: '/szhat-izobrazhenie',
      },
      {
        title: 'Посмотреть EXIF',
        description: 'Проверить дату, камеру и координаты в HEIC.',
        href: '/posmotret-exif',
      },
    ],
    howTo: [
      'Нажмите «Открыть HEIC/HEIF» или перетащите один HEIC/HEIF файл на страницу.',
      'Дождитесь локального предпросмотр и посмотрите изображение в браузере.',
      'При необходимости скачайте дополнительную копию в JPG или PNG.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только HEIC/HEIF изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      too_large: 'Файл слишком большой. Максимальный размер — 50 MB.',
      too_large_image: 'Фото слишком большое для открытия в браузере.',
      decode_failure: 'Браузер не смог показать расшифрованный HEIC. Попробуйте другой браузер.',
      corrupt:
        'Не удалось открыть HEIC/HEIF. Возможно, файл повреждён, содержит неподдерживаемый вариант формата или доступен только как последовательность кадров.',
      canvas: 'Не удалось подготовить изображение для скачивания.',
      conversion: 'Не удалось подготовить файл для скачивания.',
      generic: 'Ошибка открытия HEIC',
    },
    faq: [
      {
        question: 'Файл отправляется на сервер?',
        answer:
          'Нет. HEIC/HEIF декодируется в браузере. Предпросмотр и скачивание JPG/PNG выполняются локально на устройстве.',
      },
      {
        question: 'Чем просмотр отличается от HEIC в JPG?',
        answer:
          'Здесь главное действие — открыть и посмотреть HEIC. Копию в JPG или PNG можно скачать сразу после просмотра.',
      },
      {
        question: 'Когда лучше использовать конвертер HEIC?',
        answer:
          'Если нужно обработать до 10 файлов или выбрать JPG, PNG либо WebP, переходите в единый HEIC-конвертер.',
      },
      {
        question: 'Что будет с Live Photo или HEIC с несколькими кадрами?',
        answer:
          'Страница показывает первый кадр. Если файл содержит несколько кадров, страница покажет предупреждение; видео из Live Photo и метаданные не переносятся.',
      },
    ],
  },

  jpgViewer: {
    howToTitle: 'Как пользоваться',
    eyebrow: 'Просмотр JPG',
    title: 'Открыть JPG онлайн',
    description:
      'Загрузите один JPG или JPEG файл, посмотрите изображение в браузере и проверьте имя, вес, размеры, MIME-тип и формат. Файл остаётся на устройстве.',
    acceptedFormats: 'JPG, JPEG',
    dropTitle: 'Перетащите JPG или JPEG сюда',
    dropDescription:
      'Выберите один JPG или JPEG до 50 MB.',
    chooseFile: 'Выбрать JPG',
    loading: 'Открываем...',
    previewTitle: 'Просмотр изображения',
    previewAlt: 'Предпросмотр JPG',
    dimensions: 'Габариты',
    relatedToolsTitle: 'Похожие инструменты',
    privacyNote:
      'Файл не отправляется на сервер. JPG открывается средствами браузера; просмотр и сведения о файле считаются локально.',
    relatedTools: [
      {
        title: 'JPG -> PNG',
        description: 'Сохранить открытую фотографию в PNG без JPG-сжатия.',
        href: '/konverter-izobrazheniy',
      },
      {
        title: 'JPG -> WebP',
        description: 'Подготовить WebP-копию для сайта или блога.',
        href: '/v-webp',
      },
      {
        title: 'Сжать JPG',
        description: 'Уменьшить вес файла с настройкой качества.',
        href: '/szhat-izobrazhenie',
      },
      {
        title: 'Изменить размер',
        description: 'Задать новую ширину и высоту изображения.',
        href: '/izmenit-razmer-foto',
      },
      {
        title: 'Удалить EXIF',
        description: 'Очистить метаданные перед публикацией.',
        href: '/udalit-exif',
      },
    ],
    howTo: [
      'Выберите один JPG или JPEG файл на устройстве.',
      'Проверьте предпросмотр, габариты, вес файла и MIME-тип.',
      'Настройте масштаб или перейдите к сжатию, изменению размера, удалению EXIF или конвертации.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только JPG и JPEG изображения.',
      too_large: 'Файл слишком большой. Максимальный размер — 50 MB.',
      too_large_image:
        'Изображение слишком большое для открытия в браузере. Попробуйте файл с меньшим разрешением.',
      corrupt: 'Не удалось открыть изображение. Возможно, файл повреждён.',
      decode_failure:
        'Браузер не смог декодировать JPG. Попробуйте открыть файл в другом браузере или пересохранить изображение.',
    },
    faq: [
      {
        question: 'Файл отправляется на сервер?',
        answer:
          'Нет. JPG открывается браузером локально: файл не загружается на сервер и не покидает устройство.',
      },
      {
        question: 'Можно открыть JPEG с расширением .jpeg?',
        answer:
          'Да. Страница принимает .jpg и .jpeg файлы с MIME-типом image/jpeg.',
      },
      {
        question: 'Что можно сделать после просмотра?',
        answer:
          'Можно перейти к конвертации JPG в PNG или WebP, сжатию, изменению размера или удалению EXIF-данных.',
      },
    ],
  },

  heicToJpg: {
    eyebrow: 'HEIC в JPG, PNG или WebP',
    title: 'Конвертер HEIC в JPG, PNG и WebP',
    description:
      'Конвертируйте HEIC и HEIF фотографии в JPG онлайн бесплатно или выберите PNG и WebP. Обработка идёт локально в браузере: файлы не отправляются на сервер.',
    dropTitle: 'Перетащите HEIC или HEIF сюда',
    dropDescription:
      'Добавьте до 10 HEIC/HEIF файлов размером до 50 MB каждый, выберите JPG, PNG или WebP и скачайте результаты по одному или ZIP-архивом.',
    chooseFiles: 'Выбрать HEIC',
    outputLabel: 'Формат результата',
    outputHelp:
      'JPG подходит для обычных фото, PNG не добавляет JPEG-сжатие, WebP удобен для веб-публикаций. Каждый HEIC использует общий локальный decode pipeline.',
    viewerLink: 'Нужно только открыть HEIC? Перейти к просмотру',
    skippedNotice:
      'Некоторые файлы пропущены: поддерживаются только HEIC/HEIF до 50 MB на файл.',
    multiFrameWarning:
      'В этом файле несколько кадров. В результат сохранён первый кадр; Live Photo/video-часть не переносится.',
    privacyNote:
      'Файлы не отправляются на сервер. HEIC декодируется прямо в браузере, там же создаются JPG, PNG и WebP.',
    qualityHowTo: 'выберите баланс размера и качества JPG',
    howTo: [
      'Добавьте до 10 HEIC или HEIF файлов размером до 50 MB каждый.',
      'Выберите JPG, PNG или WebP; для JPG и WebP при необходимости настройте качество.',
      'Запустите локальную конвертацию и скачайте результаты по одному или ZIP-архивом.',
    ],
    errorsText: {
      unsupported: 'Поддерживаются только HEIC/HEIF изображения.',
      tooLarge: 'Файл слишком большой. Максимальный размер — 50 MB.',
      tooMany: 'За один запуск можно добавить не более 10 файлов.',
      corrupt:
        'Не удалось открыть HEIC/HEIF. Возможно, файл повреждён или использует неподдерживаемый вариант формата.',
      conversion:
        'Не удалось конвертировать HEIC. Попробуйте другой файл или сохраните фото как совместимый JPG на устройстве.',
      generic: 'Ошибка конвертации HEIC',
    },
    faq: [
      {
        question: 'Файлы отправляются на сервер?',
        answer:
          'Нет. HEIC/HEIF декодируется и сохраняется в выбранный JPG, PNG или WebP прямо в браузере. Файлы, их имена, EXIF и содержимое не передаются в аналитику.',
      },
      {
        question: 'Как выбрать между JPG, PNG и WebP?',
        answer:
          'JPG обычно подходит для фотографий и остаётся форматом по умолчанию. PNG не добавляет JPEG-сжатие, но часто весит больше. WebP требует поддержки canvas-кодирования в браузере.',
      },
      {
        question: 'Что будет с Live Photo или HEIC с несколькими кадрами?',
        answer:
          'Страница сохраняет один файл выбранного формата из первого кадра. Анимация, видео из Live Photo, EXIF и исходный цветовой профиль не переносятся. Некоторые варианты HEIF декодер не поддерживает.',
      },
    ],
  },

  htmlToImage: {
    title: 'HTML в картинку онлайн',
    description:
      'Вставьте HTML или загрузите .html файл, выберите размер холста и скачайте PNG или JPG. Отрисовка идёт локально в изолированном предпросмотре.',
    summaryTitle: 'MVP',
    privacyNote:
      'HTML не отправляется на сервер. Скрипты и внешние ресурсы очищаются перед показом и экспортом.',
    inputTypeLabel: 'Ввод',
    inputTypeValue: 'Pasted HTML / .html файл',
    processingLabel: 'Обработка',
    processingValue: 'Локально в браузере',
    outputLabel: 'Формат',
    resultSizeLabel: 'Размер файла',
    editorTitle: 'HTML',
    editorDescription:
      'Подходит для карточек, баннеров, email-блоков и небольших статических фрагментов.',
    htmlLabel: 'HTML код',
    uploadHtml: 'Загрузить .html',
    resetExample: 'Вернуть пример',
    settingsTitle: 'Экспорт',
    settingsDescription:
      'Задайте размер изображения и формат результата. Большие холсты ограничены для стабильной работы браузера.',
    widthLabel: 'Ширина',
    heightLabel: 'Высота',
    formatLabel: 'Формат',
    previewTitle: 'Предпросмотр HTML',
    renderButton: 'Сделать картинку',
    rendering: 'Рендер...',
    downloadButton: 'Скачать',
    howTo: [
      'Вставьте HTML в редактор или загрузите локальный .html файл.',
      'Выберите ширину, высоту и формат PNG или JPG.',
      'Нажмите кнопку рендера и скачайте готовую картинку.',
    ],
    errorsText: {
      emptyHtml: 'Вставьте HTML перед экспортом.',
      invalidSize: 'Укажите корректную ширину и высоту.',
      tooLargeCanvas:
        'Холст слишком большой для браузера. Уменьшите ширину или высоту.',
      renderFailed:
        'Не удалось отрисовать HTML. Проверьте разметку и уберите неподдерживаемые внешние ресурсы.',
      exportFailed: 'Не удалось сохранить изображение.',
      unsupportedFile: 'Поддерживается только .html файл.',
      readFailed: 'Не удалось прочитать HTML файл.',
    },
    faq: [
      {
        question: 'Можно вставить URL сайта?',
        answer:
          'Нет. Для этого нужен серверный браузер, поэтому страница работает с вставленным HTML и локальным .html файлом.',
      },
      {
        question: 'HTML отправляется на сервер?',
        answer:
          'Нет. HTML очищается, показывается в изолированном предпросмотре и сохраняется в PNG/JPG прямо в браузере.',
      },
      {
        question: 'Почему внешние картинки или шрифты могут пропасть?',
        answer:
          'Инструмент не загружает внешние ресурсы из HTML: так содержимое остаётся на устройстве.',
      },
    ],
  },

  onlinePaint: {
    eyebrow: 'Пустой холст · локально',
    title: 'Рисовать онлайн на холсте',
    description:
      'Нарисуйте схему, заметку или иллюстрацию на пустом холсте. Кисть, фигуры, стрелки, текст, отмена действий и экспорт без отправки данных на сервер.',
    toolbar: 'Панель рисования',
    canvasSize: 'Размер холста',
    presets: {
      default: 'Обычный',
      square: 'Квадрат',
      wide: 'Широкий 16:9',
      a4: 'A4 вертикальный',
    },
    tool: 'Инструмент',
    tools: {
      brush: 'Кисть',
      eraser: 'Ластик',
      line: 'Линия',
      rectangle: 'Прямоугольник',
      ellipse: 'Эллипс',
      arrow: 'Стрелка',
      text: 'Текст',
    },
    color: 'Цвет',
    background: 'Фон',
    strokeWidth: 'Толщина',
    textValue: 'Текст надписи',
    textSize: 'Размер текста',
    undo: 'Отменить',
    redo: 'Повторить',
    clear: 'Очистить холст',
    opaque: 'Непрозрачный фон',
    commandCount: 'Действия',
    download: 'Скачать:',
    exporting: 'Готовим файл локально…',
    privacy:
      'Рисунок и текст остаются в браузере. На сервер отправляются только обычные обезличенные события использования без содержимого холста.',
    howToTitle: 'Как рисовать онлайн',
    howTo: [
      'Выберите размер пустого холста, цвет фона и инструмент.',
      'Рисуйте мышью, пером или пальцем; добавляйте фигуры, стрелки и текст.',
      'Используйте отмену и повтор, затем скачайте PNG, JPG или WebP.',
    ],
    faqTitle: 'Вопросы о рисовании',
    faq: [
      {
        question: 'Рисунок и текст отправляются на сервер?',
        answer: 'Нет. Холст создаётся и экспортируется локально в браузере, без загрузки содержимого на backend.',
      },
      {
        question: 'Какой размер будет у скачанного изображения?',
        answer: 'Файл сохраняется в реальном размере выбранного холста. Масштаб предпросмотра на экране не меняет разрешение экспорта.',
      },
      {
        question: 'Чем отличаются PNG, JPG и WebP?',
        answer: 'PNG подходит для чёткой графики, JPG обычно даёт совместимый компактный файл, WebP может весить меньше. Холст всегда имеет выбранный непрозрачный фон.',
      },
    ],
    relatedTitle: 'Другие инструменты',
    related: [
      { href: '/izmenit-razmer-foto', label: 'Изменить размер изображения' },
      { href: '/obrezat-foto', label: 'Обрезать изображение' },
      { href: '/vybrat-cvet-s-kartinki', label: 'Выбрать цвет с картинки' },
    ],
    errors: {
      canvas: 'Не удалось открыть холст в этом браузере.',
      export: 'Не удалось сохранить рисунок. Попробуйте другой формат.',
      unsupportedFormat: 'Браузер не поддерживает выбранный формат экспорта.',
      textRequired: 'Введите текст, затем нажмите на холст.',
      commandLimit: 'Достигнут безопасный лимит действий. Скачайте рисунок или очистите холст.',
      pointLimit: 'Достигнут безопасный лимит точек. Скачайте рисунок или очистите холст.',
    },
  },

  photoCollage: {
    howTo: [
      'Добавьте от 2 до 12 фотографий JPG, PNG или WebP.',
      'Выберите сетку, порядок, пропорции, поля и точку кадрирования каждого слота.',
      'Соберите коллаж локально и скачайте JPG или PNG.',
    ],
    faq: [
      {
        question: 'Фотографии отправляются на сервер?',
        answer:
          'Нет. Исходные файлы остаются в браузере, а полноразмерный коллаж собирается локально в отдельном worker.',
      },
      {
        question: 'Можно изменить кадрирование каждого фото?',
        answer:
          'Да. Для каждого слота настраивается горизонтальная и вертикальная точка фокуса.',
      },
      {
        question: 'Сколько фотографий можно добавить?',
        answer:
          'От 2 до 12. Дополнительно действуют безопасные лимиты суммарных пикселей, памяти и времени экспорта.',
      },
    ],
  },

  imageGifMaker: {
    howTo: [
      'Добавьте от 2 до 20 статичных изображений JPG, PNG или WebP.',
      'Расположите кадры, настройте общую или индивидуальную задержку и повтор.',
      'Выберите размер и способ заполнения, затем создайте и скачайте GIF.',
    ],
    faq: [
      { question: 'Фото отправляются на сервер?', answer: 'Нет. Проверка, предпросмотр и кодирование GIF выполняются локально в браузере.' },
      { question: 'Почему оттенки могут измениться?', answer: 'GIF хранит ограниченную палитру и бинарную прозрачность. Инструмент использует до 255 цветов без дизеринга.' },
      { question: 'Можно добавить готовый GIF или видео?', answer: 'Нет. Принимаются только статичные JPG, PNG и WebP; анимированные изображения и видео отклоняются.' },
    ],
  },

  socialMediaResize: {
    howTo: [
      'Добавьте от одного до четырёх локальных JPG, PNG или WebP.',
      'Укажите фокус каждого исходника и при необходимости сдвиньте отдельный кадр.',
      'Выберите размеры, создайте результаты последовательно и скачайте файлы или ZIP.',
    ],
    faq: [
      {
        question: 'Изображения загружаются на сервер?',
        answer:
          'Нет. Проверка, декодирование, кадрирование, изменение размера и ZIP выполняются локально в браузере.',
      },
      {
        question: 'Все размеры официальные?',
        answer:
          'Нет. Интерфейс отдельно отмечает официальные требования, рекомендации imgify и производные safe-zone.',
      },
      {
        question: 'Гарантирует ли imgify вид изображения после публикации?',
        answer:
          'Нет. Imgify гарантирует экспортированное полотно и размер файла, но сторонняя платформа может повторно сжать или обрезать его.',
      },
    ],
  },

  blog: {
    breadcrumb: 'Блог',
    title: 'Блог imgify',
    description:
      'Практические заметки про форматы изображений, вес файлов, локальную обработку и подготовку картинок для сайтов.',
    languageAria: 'Язык статей',
    postLanguageAria: 'Язык статьи',
    empty: 'На этом языке пока нет записей.',
    notFoundTitle: 'Пост не найден',
    notFoundDescription: 'Такой заметки в блоге imgify нет или ссылка устарела.',
    relatedTools: 'Связанные инструменты',
    localeName: {
      ru: 'Русский',
      en: 'English',
    },
  },

  seo: {
    onlinePaint: {
      title: 'Рисовать онлайн бесплатно на холсте — imgify.ru',
      description:
        'Рисуйте онлайн на пустом холсте бесплатно: кисть, ластик, линии, фигуры, стрелки, текст, отмена и экспорт PNG, JPG или WebP прямо в браузере.',
    },
    index: {
      title: 'Инструменты для изображений онлайн бесплатно - imgify.ru',
      description:
        'Бесплатные локальные инструменты для изображений: конвертер PNG в JPG и JPG в PNG. Без регистрации и отправки файлов на сервер. Работает в браузере.',
    },
    imageConverter: {
      title: 'Конвертер изображений PNG и JPG онлайн - imgify.ru',
      description:
        'Конвертируйте PNG в JPG и JPG в PNG бесплатно: выбор направления, качество JPG, пакетная локальная обработка без отправки файлов на сервер.',
    },
    cropImage: {
      title: 'Обрезать фото онлайн бесплатно - imgify.ru',
      description:
        'Обрежьте JPG, PNG или WebP онлайн бесплатно. Свободная обрезка, пресеты 1:1, 4:3, 16:9 и 3:4, локальная обработка в браузере без загрузки на сервер.',
    },
    rotateImage: {
      title: 'Повернуть фото онлайн бесплатно - imgify.ru',
      description:
        'Поверните JPG, PNG или WebP онлайн бесплатно. Поворот на 90, 180 и 270 градусов, отражение по горизонтали и вертикали, локальная обработка без загрузки на сервер.',
    },
    blurImage: {
      title: 'Размыть фото онлайн бесплатно - imgify.ru',
      description:
        'Размойте или пикселизируйте области на JPG, PNG или WebP бесплатно. Ручное выделение прямоугольников, настройка силы эффекта и локальная обработка без загрузки на сервер.',
    },
    watermarkImage: {
      title: 'Водяной знак на фото онлайн бесплатно - imgify.ru',
      description:
        'Добавьте текстовый водяной знак на JPG, PNG или WebP бесплатно. Позиция, прозрачность, размер, поворот, выбор формата и локальная обработка без загрузки на сервер.',
    },
    photo3x4: {
      title: 'Фото 3x4 онлайн бесплатно - imgify.ru',
      description:
        'Сделайте фото 3x4 онлайн бесплатно: рамка 3:4, размеры 300x400, 600x800 или свой, фон для прозрачности и локальная обработка без загрузки на сервер.',
    },
    photoCollage: {
      title: 'Коллаж из фото онлайн бесплатно - imgify.ru',
      description:
        'Сделайте коллаж из 2–12 фото онлайн: готовые сетки, порядок, кадрирование, поля, фон, JPG и PNG. Файлы остаются в браузере.',
    },
    imageGifMaker: {
      title: 'Создать GIF из фото онлайн бесплатно - imgify.ru',
      description:
        'Соберите GIF из 2–20 JPG, PNG или WebP: порядок, задержки, повтор, вписывание и локальное кодирование без загрузки файлов на сервер.',
    },
    compressImage: {
      title: 'Сжать изображение онлайн бесплатно - imgify.ru',
      description:
        'Сжимайте JPG и WebP по качеству или до заданного размера, а PNG — пересохранением в браузере. Локальная обработка, предпросмотр и ZIP без загрузки на сервер.',
    },
    removeExif: {
      title: 'Удалить EXIF и метаданные фото онлайн бесплатно - imgify.ru',
      description:
        'Удалите распознаваемые EXIF, XMP, текстовые метаданные и время из JPG, PNG и WebP локально в браузере без загрузки файла на сервер.',
    },
    metadataViewer: {
      title: 'Посмотреть EXIF и метаданные фото онлайн - imgify.ru',
      description:
        'Посмотрите EXIF, IPTC, XMP, GPS и поля с личными данными JPG, TIFF или HEIC локально в браузере без отправки файла и метаданных на сервер.',
    },
    physicalPhotoSize: {
      title: 'Размер фото в сантиметрах и PPI онлайн - imgify.ru',
      description:
        'Узнайте размер фото в пикселях и сантиметрах, проверьте PPI в JFIF, Exif или PNG pHYs и рассчитайте печать локально без загрузки на сервер.',
    },
    imageToWebp: {
      title: 'Конвертер JPG и PNG в WebP онлайн бесплатно - imgify.ru',
      description:
        'Конвертируйте JPG, JPEG и PNG в WebP бесплатно. Локальная обработка в браузере, настройка качества WebP, предпросмотр результата и ZIP-архив.',
    },
    webpConverter: {
      title: 'Конвертер WebP в JPG и PNG онлайн бесплатно - imgify.ru',
      description:
        'Конвертируйте WebP в JPG или PNG бесплатно. Локальная обработка в браузере, выбор формата результата, качество JPG, предпросмотр и ZIP-архив.',
    },
    avifConverter: {
      title: 'AVIF конвертер онлайн бесплатно - imgify.ru',
      description:
        'Конвертируйте JPG, PNG и WebP в AVIF или AVIF в JPG/PNG бесплатно. Локальная обработка в браузере, предпросмотр, сравнение размера и без backend.',
    },
    tiffToJpg: {
      title: 'Конвертер TIFF в JPG онлайн бесплатно - imgify.ru',
      description:
        'Конвертируйте TIFF и TIF в JPG бесплатно. Локальная обработка через UTIF.js, качество JPG, пакетное скачивание, ZIP-архив и без загрузки на сервер.',
    },
    svgConverter: {
      title: 'Конвертер SVG в PNG и JPG онлайн бесплатно - imgify.ru',
      description:
        'Конвертируйте SVG в PNG или JPG бесплатно. Локальная обработка в браузере, выбор размера, фон для JPG и понятные ошибки для неподдерживаемых SVG.',
    },
    htmlToImage: {
      title: 'HTML в картинку онлайн бесплатно - imgify.ru',
      description:
        'Конвертируйте HTML в PNG или JPG бесплатно. Вставленный код или .html файл, локальный предпросмотр и скачивание.',
    },
    resizeImage: {
      title: 'Изменить размер фото онлайн бесплатно - imgify.ru',
      description:
        'Уменьшите JPG, PNG или WebP онлайн бесплатно. Ширина, высота, сохранение пропорций, пресеты 50% и 25%, локальная обработка без загрузки на сервер.',
    },
    socialMediaResize: {
      title: 'Размер фото для соцсетей онлайн бесплатно - imgify.ru',
      description:
        'Подготовьте фото для VK, Telegram, YouTube и аватара: кадрирование по точке фокуса, шесть проверенных размеров, отдельные JPG и ZIP локально без загрузки на сервер.',
    },
    upscaleImage: {
      title: 'Увеличить фото онлайн бесплатно - imgify.ru',
      description:
        'Увеличьте JPG, PNG или WebP онлайн бесплатно: 2x, 3x, 4x или свой размер. Локальное масштабирование без загрузки файла на сервер.',
    },
    faviconGenerator: {
      title: 'Генератор favicon онлайн бесплатно - imgify.ru',
      description:
        'Создайте favicon package из PNG, JPG или WebP бесплатно. PNG 16, 32, 180, 192, 512 px, site.webmanifest, ZIP и локальная обработка в браузере.',
    },
    heicToJpg: {
      title: 'HEIC в JPG онлайн, PNG и WebP — конвертер imgify.ru',
      description:
        'Конвертируйте HEIC и HEIF в JPG онлайн бесплатно или выберите PNG и WebP. До 10 файлов, локальная обработка, настройка качества и ZIP.',
    },
    heicViewer: {
      title: 'Открыть HEIC онлайн: посмотреть файл бесплатно - imgify.ru',
      description:
        'Посмотрите HEIC и HEIF фото онлайн без загрузки на сервер. Предпросмотр в браузере, локальная обработка и дополнительное скачивание JPG/PNG.',
    },
    jpgViewer: {
      title: 'Открыть JPG онлайн бесплатно - imgify.ru',
      description:
        'Откройте JPG и JPEG онлайн без загрузки на сервер. Предпросмотр, масштаб, размер файла, габариты, MIME-тип и быстрые действия для изображения.',
    },
    avifViewer: { title: 'Открыть AVIF онлайн бесплатно - imgify.ru', description: 'Откройте AVIF онлайн без загрузки на сервер. Просмотр, масштабирование и сохранение в JPG или PNG.' },
    pngViewer: {
      title: 'Открыть PNG онлайн: просмотр с прозрачностью - imgify.ru',
      description:
        'Откройте PNG онлайн без загрузки на сервер. Просмотр прозрачности на шахматном фоне, масштаб, размер файла, габариты и быстрые действия.',
    },
    webpViewer: {
      title: 'Открыть WebP онлайн: просмотр файла бесплатно - imgify.ru',
      description:
        'Откройте WebP онлайн без загрузки на сервер. Локальный предпросмотр, масштабирование, размер и габариты файла, дополнительное сохранение в JPG или PNG.',
    },
    svgViewer: {
      title: 'Открыть SVG онлайн: безопасный просмотр - imgify.ru',
      description:
        'Откройте SVG онлайн без загрузки на сервер. Безопасный очищенный предпросмотр, имя, размер, габариты и дополнительный экспорт в PNG или JPG.',
    },
    imageColorPicker: {
      title: 'Выбрать цвет с картинки онлайн бесплатно - imgify.ru',
      description:
        'Выберите цвет пикселя на JPG, PNG или WebP онлайн. Лупа, масштаб, HEX, RGB, HSL, HSV и alpha без загрузки изображения на сервер.',
    },
    tiffViewer: {
      title: 'Открыть TIFF или TIF онлайн бесплатно - imgify.ru',
      description: 'Откройте TIFF и TIF онлайн без загрузки на сервер. Локальный предпросмотр первого кадра, число страниц и экспорт в JPG.',
    },
    gifViewer: {
      title: 'Открыть GIF онлайн: просмотр анимации - imgify.ru',
      description:
        'Откройте GIF онлайн без загрузки на сервер. Анимация в браузере, размер файла, габариты и сохранение кадра в PNG или JPG.',
    },
    bmpViewer: {
      title: 'Открыть BMP онлайн бесплатно - imgify.ru',
      description:
        'Откройте BMP онлайн без загрузки на сервер. Просмотр, размер файла, габариты и сохранение в PNG или JPG.',
    },
    icoViewer: {
      title: 'Открыть ICO онлайн: просмотр значка - imgify.ru',
      description:
        'Откройте ICO онлайн без загрузки на сервер. Просмотр значка, размеры внутри файла и сохранение в PNG или JPG.',
    },
    blog: {
      title: 'Блог imgify - заметки про изображения и форматы',
      description:
        'Практические статьи про PNG, JPG, сжатие изображений, локальную обработку файлов и подготовку картинок для сайта.',
    },
  },
}

export type Translations = typeof ruTranslations
